import React, { useCallback, useEffect, useRef, useState } from "react";
import {Container, Modal, Row, Col, Button} from "react-bootstrap";
import { useSelector } from "react-redux";
import APICom from "../utils/helpers/APICom.js";
import {Icon} from '@iconify/react';
import * as XLSX from 'xlsx';
import GridControl from "../components/Controls/gridControl.js";
import 'react-phone-number-input/style.css';
import PhoneInput from "react-phone-number-input/input";
import MapControlSkeleton from "../components/Controls/mapControlSkeleton.js";
import PersistStorage from "../utils/helpers/PersistStorage.js";
import ARBResponseListener from "../components/Controls/ARBResponseListener.js";
import ExportIcon from "../assets/Images/CommonImages/save.png";
import ClearFilterIcon from "../assets/Images/CommonImages/clearFilter.png";
import ITCLogo from '../assets/Images/CommonImages/ITClogo.png';

const CallTaker = (props) => {

  const [conditionMet, setConditionMet] = useState(false);
  const [isHandleResetCalled, setIsHandleResetAll] = useState(false);
  const puVSCallValidation = useRef(false);
  const doVSCallValidation = useRef(false);
  const puVSValueChanged = useRef("");
  const doVSValueChanged = useRef("");
  const iAppID = 26;
  const [isSchTimeFieldDisabled, setIsSchTimeFieldDisabled] = useState(true);
  const [isVSSelectionDisabled, setIsVSSelectionDisabled] = useState(false);
  const isValidateRCZCalledFromReset = useRef(false);
  const isFirstRender = useRef(true);
  const [isTimeValidated, setIsTimeValidated] = useState(true);
  const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  const { loginData }  = useSelector((store) => store.login);
  const { GlobalASCSData, ASCSSettingData, DispatchVehicleData, AffiliateData, FundingSourceData, ZoneVerticesData, 
    VirtualStopsData, RCZZoneVerticesData, PaymentTypesData, ClassOfServiceData 
  } = useSelector((store) => store.combinedata);
  const[showEditTripDialog, setShowEditTripDialog] = useState(true);
  const [showDynamicModal, setShowDynamicModal] = useState(false);
  const [modalClass, setModalClass] = useState("");
  const [modalBodyHTML, setModalBodyHTML] = useState(null);
  const [handlePageProgressBar, sethandlePageProgressBar] = useState(null); 
  const [modalFooterHTML, setModalFooterHTML] = useState(
    <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
      OK
    </Button>
  );
  // const [focusedIndex, setFocusedIndex] = useState(-1); // No item is focused initially
  // const [suggestedPUAddressArr, setSuggestedPUAddressArr] = useState([]);
  // const itemRefs = useRef([]);
  const [modalHeaderText, setModalHeaderText] = useState("");
  const [clientInfoDisplay, setClientInfoDisplay] = useState(true);
  const [affiliateDropDownHTML, setAffiliateDropDownHTML] = useState(null);
  const [virtualStopDropDownHTML, setVirtualStopDropDownHTML] = useState(null);
  const[submitBtnTitle, setSubmitBtnTitle] = useState("");
  const [inputSuggestionListClientName, setInputSuggestionListClientName] = useState(null);
  const [inputSuggestionListPU, setInputSuggestionListPU] = useState(null);
  const [inputSuggestionListDO, setInputSuggestionListDO] = useState(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [highlightedIndexDO, setHightlightedIndexDO] = useState(-1);
  // const [enableTimeSelection, setEnableTimeSelection] = useState(false);
  // const [intervalId, setIntervalId] = useState(null);
  const liRefRecentDropoffAddressComponenet = useRef([]); // Array to hold refs for each <li> PU
  const liRefRecentPickupAddressComponenet = useRef([]); // Array to hold refs for each <li> PU
  const liRefPickupAddressComponenet = useRef([]); // Array to hold refs for each <li> PU
  const liRefDropoffAddressComponenet = useRef([]); // Array to hold refs for each <li> PU
  const liRefs = useRef([]); // Array to hold refs for each <li> PU
  const liRefsDO = useRef([]); // Array to hold refs for each <li> DO
  const xCancelSourceForGrid = useRef(null);
  const bookBtnRef = useRef(null);
  const resetBtnRef = useRef(null);
  const agentNotesBtnRef = useRef(null);
  const phoneRef = useRef(null);
  const clientNameCheckRef = useRef(null);
  const riderNameRef = useRef(null);
  const focusedSuggestionCheckPU = useRef(false);
  const focusedSuggestionCheckDO = useRef(false);
  const [riderNameCheck, setRiderNameCheck] = useState("");
  const [microtransit, setMicrotransit] = useState(true);
  const [ShowAPILoader, setShowAPILoader] = useState(false);
  const vsChangeRef = useRef({type:""});
  const [MTSMTableHTML, setMTSMTableHTML] = useState(null);
  const [mapVsSelected, setMapVSSelected] = useState([]);
  const [mapPointSelection, setMapPointSelection] = useState([]);

  const mapPointPickupSelection = useRef([]);
  const mapPointDropoffSelection = useRef([]);
  
  const [rczVerifData, setRczVerifData] = useState([]);
  const [showClientActiveTripsModal, setShowClientActiveTripsModal] = useState(false);
  const [searchButtonValidation, setSearchButtonValidation] = useState("");
  const [activeTripConfirmation, setActiveTripConfirmation] = useState("");
  const tempConfRef = useRef("");
  const cancelAPICounterRef = useRef(0);
  const searchClientBtnRef = useRef(null);
  const vsSelectedRef = useRef([]);
  const clientIndexRef = useRef(0);
  const transitTypeRef = useRef([]);
  // const PUListRef = useRef(null);
  const [TotalMTSMRecords, setTotalMTSMRecords] = useState(0);
  //-------------------------------------------------------------Client Info Active Trips Modal
  const [showLoader, setShowLoader] = useState(false);
  const [ActiveTripsTableData, setActiveTripsTableData] = useState([]);
  const activeTripsTableObjRef = useRef(null);
  const [activeTripsGridOptions, setActiveTripsGridOptions] = useState({
    height: 300,
    heightoffset: 600,
    calculateHeight: false,
    pagination: true,
    sortCondition: true,
    paginationMode: "local",
    paginationSize: [500, 1000, 2000],
    selectable: 1,
    reactiveData:false, //enable data reactivity
    layout: "fitDataStretch",
    placeholder:"No Data Available",
    clipboard: false,
    selectableRangeMode: "click",
    GridName:"clientInfoActiveTripsTable",
    paginationCounter:"rows",
    intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
    movableColumns:true,
    vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
    index: "iRefId",
    autoColumns: true,
    bSysUser: 1,
    intervalEnable: false,
    persistence: false,
    bWebApplySettingToAll: true,
    GridReturnOnlyIDColumnInRowData: false,
    containerClass: "col position-relative",
    Containerstyle: {},
    footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
    +"clientInfoActiveTripsTable"+'_Export"></button><button class="tabulator_btns lastTabulator-btn" '
    +' title="Clear Filters" id="'+"clientInfoActiveTripsTable"+'_ClearFilters"></button>',
    tableDoubleClickFunc: function(table, row) {
      try{
        
      }
      catch(err){console.log(err);}
    },
    footerElementHandles: function (table) {
        activeTripsTableObjRef.current = table;
        // activeTripsTableObjRef.current.selectRow( activeTripsTableObjRef.current.getData()[0].iManifestNumber);
        var img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px"; 
            img.src = ExportIcon;
            document.getElementById("clientInfoActiveTripsTable_Export").appendChild(img);

        var img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px"; 
            img.src = ClearFilterIcon;
            document.getElementById("clientInfoActiveTripsTable_ClearFilters").appendChild(img);

        document.getElementById("clientInfoActiveTripsTable_Export").addEventListener("click", function(){
            const data = table.getData('active');
            const columnsToIgnore = ['id'];
            var filteredData = data.map(row =>{
                const filteredRow = {...row};
                columnsToIgnore.forEach(column => delete filteredRow[column]);
                return filteredRow;
            });
            
            const sheet = XLSX.utils.json_to_sheet(filteredData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
            XLSX.writeFile(wb, "ActiveTrips_data.xlsx");
            
        });
        document.getElementById('clientInfoActiveTripsTable_ClearFilters').addEventListener("click", function(){
            table.clearHeaderFilter();
        });
    },
    rowSelectionChangeHandle: async function(data){
      try{

      }
      catch(err){console.log(err);}
    },
    ActionList: true,
    listofCheckBoxCols : [],
    AlwaysHiddenColumns: []
  });
  //-------------------------------------------------------------
  //-------------------------------------------------------------Client Info
  const [FSDropdown, setFSDropdown] = useState([]);
  const [COSDropdown, setCOSDropdown] = useState([]);
  const [PayDropdown, setPayDropdown] = useState([]);
  const [COSSelected, setCOSSelected] = useState(1);
  const [PaySelected, setPaySelected] = useState(1);
  const [FSSelected, setFSSelected] = useState("");
  const [FSTargetID, setFSTargetID] = useState("");
  const [PayTargetID, setPayTargetID] = useState("");
  const [clientInfo, setClientInfo] = useState("");
  const [schTime, setSchTime] = useState("");
  const rowData = useRef([]);
  const [recentAddresses, setRecentAddresses] = useState([]);
  const [phone, setPhone] = useState(null);
  const [callBackPhone, setCallBackPhone] = useState(null);
  const [riderName, setRiderName] = useState("");
  const [selectedAff, setSelectedAff] = useState(()=>{
    let storedSelection = PersistStorage.retrieve("affSelectedCallAgent", true);
    if(storedSelection) {
      if(storedSelection.includes(","))
      {
        return (AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID || 125;
      }
      else
      {
        return storedSelection;
      }
    }
    else {
      return (AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID || 125;
    }
  });
  const ITCMapURL = selectedAff ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"autocomplete?address=": "http://itcmap.itcurves.us/api/Map/autocomplete?address=";
  const ITCMapDirections = selectedAff ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"directions": "http://itcmap.itcurves.us/api/Map/directions";
  const ITCMapAutCode = "Basic QkFSV09PRDpiYXJ3b29kcGFzcw==";
  const OSRM_Username = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value;
  const OSRM_Password = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value;
  const [confirmationNo, setConfirmationNo] = useState("");
  const [schPUTime, setSchPUTime] = useState("");
  const [tripStatus, setTripStatus] = useState("");
  const [clientStatus, setClientStatus] = useState("");
  const [passengerTypeCount, setPassengerTypeCount] = useState({ambPass:1,totalWC:0,totalSA:0, total:1});
  const [clientSummary, setClientSummary] = useState({totalCalls:0, totalNS:0, totalCancels:0, 
    lastCall:"", tripDistance:0.0, TripDuration:0.0, TripFare:0.0});
  const [zones, setZones] = useState("");
  const [agentNotes, setAgentNotes] = useState("");
  const [pickupAddr, setPickupAddr] = useState("");
  const [dropAddr, setDropAddr] = useState("");
  // const [pickLatLng, setPickLatLng] = useState("");
  // const [dropLatLng, setDropLatLng] = useState("");
  const [pickupVirtualStop, setPickupVirtualStop] = useState({name:"", value:"PU VS"});
  const [dropAddrVirtualStop, setDropAddrVirtualStop] = useState({name:"", value:"DO VS"});
  const [walkDistance, setWalkDistance] = useState({PUWalk:0, DOWalk:0, PUDuration:0, DODuration:0});
  const [pickExtraInfo, setPickExtraInfo] = useState("");
  const [dropExtraInfo, setDropExtraInfo] = useState("");
  const dropLatLng = useRef("");
  const pickLatLng = useRef("");
  const searchedClientID = useRef("");
  const liClientNameRefs = useRef([]); // Array to hold refs for each <li> Client Names
  const focusedSuggestionCheckClientName = useRef(false);
  //-------------------------------------------------------------
  const [mapData, setMapData] = useState([]);
  const [mapOptionsCallAgent, setMapOptionsCallAgent] = useState({
    mapPolylines:{single:true,multiple:false},
    mapZoomOpts: {zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false},
    mapDefaultBtns: false,
    mapOptions: {tilt: 47.5, zoom: 12, zone:true, aff: selectedAff},
    GridName:"callAgent",
  });


  const triggerMapMethod = () => {
  };

  
  const checkCondition = () => {
        setConditionMet(true);
        triggerMapMethod();
  };

  // useEffect(() => {
  //   const handleKeyDown = (event) => {
  //     if (event.key === 'Tab') {
  //       const IsPhoneInputAttr = event.target.getAttribute('phoneinputattr');
  //       if(IsPhoneInputAttr == "1"){
  //         event.preventDefault(); 
  //         clientNameCheckRef?.current.focus();
  //       }
  //       console.log('Tab key pressed');
  //     }
  //   };
  //   window.addEventListener('keydown', handleKeyDown);

  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, []);

  useEffect(() => {
    try{
      document.title = "Call Agent 2.0";
      console.log((AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID);
      const queryParams = new URLSearchParams(window.location.search);
      const tripSelected = queryParams.get('TripSelected')? true:false;
      bookBtnRef.current.disabled = true;
      rowData.current = (PersistStorage.retrieve("rowDataCallAgent", true)  && tripSelected? PersistStorage.retrieve("rowDataCallAgent", true):[]);
      let affCheck = PersistStorage.retrieve("affSelectedCallAgent", true);
      
      if(rowData.current && rowData.current.length > 0)
      {
        handleCancelTrip(rowData.current[0].ConfirmationNo);
        // setConfirmationNo(rowData.current[0].ConfirmationNo);
        setSchPUTime(rowData.current[0].PickupTime);
        setTripStatus((rowData.current[0].Route === ""?"Un-Routed":"Routed"));
        setClientSummary({...clientSummary, totalCalls:0, totalNS:parseInt(rowData.current[0].TotalNoShows), 
          totalCancels:parseInt(rowData.current[0].TotalCancelled), lastCall:rowData.current[0].CallRecieve,
          tripDistance:rowData.current[0].EstimatedDistance, TripDuration:rowData.current[0].EstimatedTime, TripFare:rowData.current[0].EstimatedCost
        });
        setRiderName(rowData.current[0].PickupPerson);
        setAgentNotes(rowData.current[0].ExtraInformation);
        setPhone(("+1"+rowData.current[0].Phone.replaceAll("-","")));
        if(rowData.current[0].CallbackInfo !== "")
        {
          setCallBackPhone(("+1"+rowData.current[0].CallbackInfo.replaceAll("-","")));
        }
        let ambulatoryPassCount = parseInt(rowData.current[0].nTotalPassengers) - parseInt(rowData.current[0].nTotalWheelChairs);
        setPassengerTypeCount({...passengerTypeCount, ambPass: ambulatoryPassCount, totalSA: 0,
          totalWC: parseInt(rowData.current[0].nTotalWheelChairs), totalPass: parseInt(rowData.current[0].nTotalPassengers), 
          total:parseInt(rowData.current[0].nTotalPassengers)
        });
        setPickupAddr(rowData.current[0].PickupAddress);
        setDropAddr(rowData.current[0].Destination);
        pickLatLng.current = rowData.current[0].PickupLatitude ? rowData.current[0].PickupLatitude+","+rowData.current[0].PickupLongitude:"";
        dropLatLng.current = rowData.current[0].DropLatitude ? rowData.current[0].DropLatitude+","+rowData.current[0].DropLongitude:"";
        setPickExtraInfo("POI: "+rowData.current[0].PickupPOI);
        setDropExtraInfo("POI: "+rowData.current[0].DropoffPOI);
        let tripLatLng = [];
        tripLatLng.push(
          {lat:parseFloat(pickLatLng.current.split(",")[0]),
            lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
            name:(rowData.current[0].PickupPerson), address: rowData.current[0].PickupAddress
          },
          {lat:parseFloat(dropLatLng.current.split(",")[0]),
            lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
            name:(rowData.current[0].PickupPerson), address: rowData.current[0].Destination
          },
        );
        setMapData(tripLatLng);
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          wrapperHandleAddressDetails("PU", rowData.current[0].PickupAddress);
          //handleAddressDetails("PU", rowData.current[0].PickupAddress);
          wrapperHandleRCZVerification("PU", 
          (rowData.current[0].PickupAddress.split(", ")[0]+", "+rowData.current[0].PickupCity+", "+rowData.current[0].PickupState+" "+rowData.current[0].PickupZip),
          (rowData.current[0].Destination.split(", ")[0]+", "+rowData.current[0].DropCity+", "+rowData.current[0].DropState+" "+rowData.current[0].DropZip));

        }
        setSubmitBtnTitle("Book");
      }
      else
      {
        setSubmitBtnTitle("Book");
        bookBtnRef.current.disabled = true;
      }

      // setSchTime(getCurrentTimeInNY());
      
      let selectedAffTemp = PersistStorage.retrieve("affSelectedCallAgent", true);
      let selectedAffVS = [];
      let newSelection = AffiliateData.filter((item, index)=>{
        if(parseInt(item.iTransType) === 2)
        {
          return true;
        }
      });
      // console.log(newSelection);
      selectedAffTemp = parseInt(newSelection[0].AffiliateID);
      if(affCheck)
      {
        // transitTypeRef.current = AffiliateData.filter((item,index) => {
        //   try{
        //     return parseInt(item.AffiliateID) === parseInt(affCheck);
        //   }
        //   catch(err){console.log(err);}
        // });
        transitTypeRef.current = AffiliateData.filter((item,index) => {
          try{
            return parseInt(item.AffiliateID) === parseInt(selectedAffTemp);
          }
          catch(err){console.log(err);}
        });
        let fsSelection = FundingSourceData[parseInt(selectedAffTemp)] && FundingSourceData[parseInt(selectedAffTemp)] !== undefined ? JSON.parse(FundingSourceData[parseInt(selectedAffTemp)]) : [];
        let cosSelection = ClassOfServiceData[parseInt(selectedAffTemp)] && ClassOfServiceData[parseInt(selectedAffTemp)] !== undefined ? JSON.parse(ClassOfServiceData[parseInt(selectedAffTemp)]) : [];
        let paySelection = PaymentTypesData[parseInt(selectedAffTemp)] && PaymentTypesData[parseInt(selectedAffTemp)] !== undefined ? JSON.parse(PaymentTypesData[parseInt(selectedAffTemp)]) : [];
        let fsOptionsHTML = null;
        let cosOptionsHTML = cosSelection.map((item, index)=>{
          return(
            <option key={index} value={item.iClassOfServiceID}>
              {item.vClassName}
            </option>
          );
        });
        let payOptionsHTML = paySelection.map((item, index)=>{
          if(index === 0)
          {
            setPayTargetID(item.iAPID);
            setPaySelected(item.iAPID);
          }
          if(item.vName !== "" && item.vName !== "-" && !item.vName.toLowerCase().includes("unused"))
          {
            return(
              <option key={index} value={item.iAPID}>
                {item.vName}
              </option>
            );
          }
        });
        setPayDropdown(payOptionsHTML);
        setCOSDropdown(cosOptionsHTML);
        fsOptionsHTML = fsSelection.map((item, index)=>{
          if(item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash"))
          {
            setFSSelected(item.ID);
            setFSTargetID(item.ID);
          }
          return(
            <option key={index} value={item.ID}>
              {item.AccountID}
            </option>
          );
        });
        setFSDropdown(fsOptionsHTML);
      }
      else
      {
        transitTypeRef.current = AffiliateData.filter((item,index) => {
          try{
            return parseInt(item.AffiliateID) === parseInt(selectedAffTemp);
          }
          catch(err){console.log(err);}
        });
        let fsSelection = FundingSourceData[parseInt(selectedAffTemp)] && FundingSourceData[parseInt(selectedAffTemp)] !== undefined ? JSON.parse(FundingSourceData[parseInt(selectedAffTemp)]) : [];
        let cosSelection = ClassOfServiceData[parseInt(selectedAffTemp)] && ClassOfServiceData[parseInt(selectedAffTemp)] !== undefined ? JSON.parse(ClassOfServiceData[parseInt(selectedAffTemp)]) : [];
        let paySelection = PaymentTypesData[parseInt(selectedAffTemp)] && PaymentTypesData[parseInt(selectedAffTemp)] !== undefined ? JSON.parse(PaymentTypesData[parseInt(selectedAffTemp)]) : [];
        let fsOptionsHTML = null;
        let cosOptionsHTML = cosSelection.map((item, index)=>{
          return(
            <option key={index} value={item.iClassOfServiceID}>
              {item.vClassName}
            </option>
          );
        });
        let payOptionsHTML = paySelection.map((item, index)=>{
          if(index === 0)
          {
            setPayTargetID(item.iAPID);
            setPaySelected(item.iAPID);
          }
          if(item.vName !== "" && item.vName !== "-" && !item.vName.toLowerCase().includes("unused"))
          {
            return(
              <option key={index} value={item.iAPID}>
                {item.vName}
              </option>
            );
          }
        });
        setPayDropdown(payOptionsHTML);
        setCOSDropdown(cosOptionsHTML);
        fsOptionsHTML = fsSelection.map((item, index)=>{
          if(item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash"))
          {
            setFSSelected(item.ID);
            setFSTargetID(item.ID);
          }
          return(
            <option key={index} value={item.ID}>
              {item.AccountID}
            </option>
          );
        });
        setFSDropdown(fsOptionsHTML);
      }
      for(let k = 0; k < VirtualStopsData.length; k++)
      {
        if(parseInt(selectedAffTemp) === parseInt(VirtualStopsData[k].iSATSPID) && VirtualStopsData[k].ZoneID && parseInt(VirtualStopsData[k].ZoneID) > 0)
        {
          selectedAffVS.push(VirtualStopsData[k]);
        }
      }
      // console.log(selectedAffVS);
      startAffSelectionDropDown(selectedAffVS);
      let interval = setInterval(() => {
        try{
          let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
          if(mtsmConfirmationNumList && mtsmConfirmationNumList.length > 0)
          {
            setTotalMTSMRecords(mtsmConfirmationNumList.length);
            if(mtsmConfirmationNumList.length > 4)
            {
              const currDate = new Date();
              const timeDiff = Math.abs(currDate - new Date(mtsmConfirmationNumList[0].creationTime));
              if(timeDiff >= 900000)
              {
                mtsmConfirmationNumList.shift();
              }
            }
            // const updatedMTSMConfirmationNumList = mtsmConfirmationNumList.filter((item,index) => {
            //   const currDate = new Date();
            //   const timeDiff = Math.abs(currDate - new Date(item.creationTime));
            //   // console.log(timeDiff, index);
            //   if(index > 4 && timeDiff < 900000) // Keep the record if the time difference is less than 15 minutes if it is 5th or higher index
            //   {
            //     return true;
            //   }
            //   else if(index <= 4)
            //   {
            //     return true;
            //   }
            //   else
            //   {
            //     return false;
            //   }
            // });
            PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
            // console.log(mtsmConfirmationNumList, updatedMTSMConfirmationNumList);
            let MTMSNegotiationHTML = mtsmConfirmationNumList.reverse().map(function(item, index){
              const currDate = new Date();
              const timeDiff = Math.abs(currDate - new Date(item.creationTime));
              if(timeDiff >= 90000 && (item.msg === "" || item.msg.toLowerCase().includes("failed")))
              {
                // tempConfRef.current = item.Confirmation;
                // handleRejectTrip();
                return(
                  <tr key={index} className="text-center border-bottom border-dark">
                    <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                    <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                      {"N/A"}
                    </td>
                    <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                      {"N/A"}
                    </td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                      style={{textOverflow:"ellipsis"}} title={item.name} 
                    >{item.name}</td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={"Routing system timed out"} 
                      style={{textOverflow:"ellipsis"}}
                    >{"Routing system timed out"}</td>
                    <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                      <div className="d-flex justify-content-center">
                        <Button variant="secondary" tabIndex={-1} className="d-inline-block p-1 py-0" title={"Remove trip from view"} 
                          onClick={handleRemoveRecord} name={item.Confirmation}>
                          X
                        </Button>
                        <Button variant="danger" tabIndex={-1} className="mx-1 d-inline-block p-1 py-0"
                          name={item.Confirmation} onClick={handleRejectConfirmation} data-name={"cancel"}
                        > 
                          Cancel
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
                
              }
              else if(item.msg === "" || item.msg.toLowerCase().includes("failed"))
              {
                return(
                  <tr key={index} className="text-center border-bottom border-dark">
                    <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                    <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                      {"N/A"}
                    </td>
                    <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                      {"N/A"}
                    </td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                      style={{textOverflow:"ellipsis"}} title={item.name} 
                    >{item.name}</td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={"Processing request..."} 
                      style={{textOverflow:"ellipsis"}}
                    >{"Processing request..."}</td>
                    <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                      <div className="d-flex justify-content-center">
                        <Button variant="secondary" className="d-inline-block p-1 py-0" title={"Remove trip from view"} 
                          onClick={handleRemoveRecord} tabIndex={-1} name={item.Confirmation}>
                          X
                        </Button>
                        <Button variant="danger" className="mx-1 d-inline-block p-1 py-0"
                          name={item.Confirmation} tabIndex={-1} onClick={handleRejectConfirmation} data-name={"cancel"}
                        > 
                          Cancel
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              }
              else
              {
                return(
                  <tr key={index} className="text-center border-bottom border-dark">
                    <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                    <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={item.time} style={{textOverflow:"ellipsis"}}>
                      {item.time}
                    </td>
                    <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={item.dropTime} style={{textOverflow:"ellipsis"}}>
                      {item.dropTime}
                    </td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                      style={{textOverflow:"ellipsis"}} title={item.name} 
                    >{item.name}</td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={item.msg} 
                      style={{textOverflow:"ellipsis"}}
                    >{item.msg}</td>
                    <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                      <div className="d-flex justify-content-center">
                        <Button variant="secondary" className="d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Remove trip from view"} 
                          onClick={handleRemoveRecord} tabIndex={-1} name={item.Confirmation}>
                          X
                        </Button>
                        {(item.time !== "N/A" || item.msg.toLowerCase().includes("failed")) && timeDiff < 240000?
                        <Button variant="danger" className="mx-1 d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Reject scheduled trip"} 
                          onClick={handleRejectConfirmation} tabIndex={-1} name={item.Confirmation} data-name={"reject"}>
                          Reject
                        </Button>:
                        <Button variant="danger" className="mx-1 d-inline-block p-1 py-0 opacity-0" disabled={item.time === "N/A"} 
                          name={item.Confirmation} tabIndex={-1}>
                          Reject
                        </Button>}
                      </div>
                    </td>
                  </tr>
                )
              }
              
            });
            setMTSMTableHTML(
              <>
                {MTMSNegotiationHTML}
              </>
            );
            // console.log(mtsmConfirmationNumList);
            if(mtsmConfirmationNumList && mtsmConfirmationNumList.length > 0)
            {
              setConfirmationNo(mtsmConfirmationNumList[0].Confirmation);
            }
          }
          else
          {
            setTotalMTSMRecords(0);
            
            setMTSMTableHTML(
              <>
                <tr className="text-center">
                  <td className="border border-dark user-select-none">{""}</td>
                  <td className="border border-dark user-select-none">{""}</td>
                  <td className="border border-dark user-select-none">{""}</td>
                  <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                    style={{textOverflow:"ellipsis", maxWidth:"65px", minWidth:"50px"}} title={""} 
                  >{""}</td>
                  <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""} 
                    style={{textOverflow:"ellipsis", maxWidth:"80px", minWidth:"60px"}}
                  >
                    {""}
                  </td>
                  <td className="user-select-none text-center justify-content-center">
                    {""}
                  </td>
                </tr>
              </>
            );
            setConfirmationNo("");
          }
        }
        catch(err){console.log(err);}
        
      }, 1000);
      return()=>{
        clearInterval(interval);
        // Clean up the event listener on component unmount
        window.removeEventListener('keydown', handleKeyPress);
      };
      // window.addEventListener('message',handleMessage);
    }
    catch(err){console.log(err);}
    // return ()=> window.removeEventListener('message', handleMessage);
  }, []);

  useEffect((e) => {

  },[isVSSelectionDisabled])

  useEffect(() => {
    try{
      // console.log(activeTripConfirmation);
      if(activeTripConfirmation !== "")
      {
        if(activeTripConfirmation.includes("_copy"))
        {
          let tripInfo = ActiveTripsTableData.filter((item)=>{
            try{
              if(String(item.iRefId) === String(activeTripConfirmation.replace("_copy","")))
              {
                return true;
              }
            }
            catch(err){console.log(err);}
          });
          console.log(tripInfo);
          if(tripInfo[0].ClientId != undefined && tripInfo[0].ClientId > 0 && tripInfo[0].ClientId != "")
          {
            searchedClientID.current = String(tripInfo[0].ClientId);
          }
          else
          {
            searchedClientID.current = "";
          }
          // handleCancelTrip(String(data.iRefId));
          setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
          // setClientSummary({...clientSummary, totalCalls:0, totalNS:parseInt(rowData.current[0].TotalNoShows), 
          //   totalCancels:parseInt(rowData.current[0].TotalCancelled), lastCall:rowData.current[0].CallRecieve,
          //   tripDistance:rowData.current[0].EstimatedDistance, TripDuration:rowData.current[0].EstimatedTime, TripFare:rowData.current[0].EstimatedCost
          // });
          setRiderName(tripInfo[0].PickupPerson);
          // setAgentNotes(rowData.current[0].ExtraInformation);
          // let ambulatoryPassCount = parseInt(rowData.current[0].nTotalPassengers) - parseInt(rowData.current[0].nTotalWheelChairs);
          // setPassengerTypeCount({...passengerTypeCount, ambPass: ambulatoryPassCount, totalSA: 0,
          //   totalWC: parseInt(rowData.current[0].nTotalWheelChairs), totalPass: parseInt(rowData.current[0].nTotalPassengers), 
          //   total:parseInt(rowData.current[0].nTotalPassengers)
          // });
          setPickupAddr(tripInfo[0].PickupAddress);
          setDropAddr(tripInfo[0].DropOffAddress);
          pickLatLng.current = tripInfo[0].PickupLatitude ? tripInfo[0].PickupLatitude+","+tripInfo[0].PickupLongitude:"";
          dropLatLng.current = tripInfo[0].DropLatitude ? tripInfo[0].DropLatitude+","+tripInfo[0].DropLongitude:"";
          // setPickExtraInfo("POI: "+rowData.current[0].PickupPOI);
          // setDropExtraInfo("POI: "+rowData.current[0].DropoffPOI);
          let tripLatLng = [];
          tripLatLng.push(
            {lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(tripInfo[0].PickupPerson), address: tripInfo[0].PickupAddress
            },
            {lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(tripInfo[0].PickupPerson), address: tripInfo[0].DropOffAddress
            },
          );
          setMapData(tripLatLng);
          setShowClientActiveTripsModal(false);
          if(pickLatLng.current !== "" && dropLatLng.current !== "")
          {
            wrapperHandleAddressDetails("PU", tripInfo[0].PickupAddress);
            //handleAddressDetails("PU", tripInfo[0].PickupAddress);
            wrapperHandleRCZVerification("PU", tripInfo[0].PickupAddress, tripInfo[0].DropOffAddress);
          }
          setActiveTripConfirmation("");
        }
        else
        {
          handleCancelTrip(activeTripConfirmation, "active");
          setActiveTripConfirmation("");
        }
      }
    }
    catch(err){console.log(err);}
  }, [activeTripConfirmation]);

  useEffect(() => {
    try{
      // console.log("the data: ",mapVsSelected);
      // let tripLatLng = [];
      if(mapVsSelected && mapVsSelected.length > 0)
      {
        if(mapVsSelected[0].type === "PU")
        {
          // console.log(mapVsSelected[0].data.Street, mapVsSelected[0].data.vLatitude, mapVsSelected[0].data.ID);
          setPickupAddr(mapVsSelected[0].data.Street);
          pickLatLng.current = mapVsSelected[0].data.vLatitude+","+mapVsSelected[0].data.vLongitude;
          setPickupVirtualStop({...pickupVirtualStop, value:mapVsSelected[0].data.ID, name:mapVsSelected[0].data.Location});
          let filteredMapMarkers = mapData.filter((item)=>{
            return item.Type === "DO";
          });
          // console.log(filteredMapMarkers);
          filteredMapMarkers.push(
            {lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: mapVsSelected[0].data.Street
            },
          );
          setMapData(filteredMapMarkers);
          if(dropLatLng.current !== "")
          {
            setIsSchTimeFieldDisabled(false);
            setIsVSSelectionDisabled(true);
            if(pickupVirtualStop?.name != undefined && pickupVirtualStop?.name != null){
              pickupVirtualStop.name = mapVsSelected[0].data.Location;
            }
            puVSValueChanged.current = mapVsSelected[0].data.Location;
            mapPointPickupSelection.current = mapVsSelected[0].data;
            wrapperHandleAddressDetails("PU", mapVsSelected[0].data.Street);
            //handleAddressDetails("PU", mapVsSelected[0].data.Street);
            wrapperHandleRCZVerification("PU", mapVsSelected[0].data.Street);
            setIsVSSelectionDisabled(false);
          }
        }
        else
        {
          setDropAddr(mapVsSelected[0].data.Street);
          dropLatLng.current = mapVsSelected[0].data.vLatitude+","+mapVsSelected[0].data.vLongitude;
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:mapVsSelected[0].data.ID, name:mapVsSelected[0].data.Location});
          
         
          if(pickLatLng.current !== "")
          {
            setIsSchTimeFieldDisabled(false);
            setIsVSSelectionDisabled(true);
            if(dropAddrVirtualStop?.name != undefined && dropAddrVirtualStop?.name != null){
              dropAddrVirtualStop.name = mapVsSelected[0].data.Location;
            }
            doVSValueChanged.current = mapVsSelected[0].data.Location;
            mapPointDropoffSelection.current = mapVsSelected[0].data;
            wrapperHandleAddressDetails("DO", mapVsSelected[0].data.Street);
            //handleAddressDetails("DO", mapVsSelected[0].data.Street);
            wrapperHandleRCZVerification("DO", mapVsSelected[0].data.Street);
            setIsVSSelectionDisabled(false);
          }

          let filteredMapMarkers = mapData.filter((item)=>{
            return item.Type === "PU";
          });
          filteredMapMarkers.push(
            {lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: mapVsSelected[0].data.Street
            },
          );
          //mapData.ResetMapFromCallTaker();
          setMapData(filteredMapMarkers);
        }
        
        setIsVSSelectionDisabled(false);
        
      }
    }
    catch(err){console.log(err);setIsVSSelectionDisabled(false);}
  }, [mapVsSelected]);

  useEffect(() => {
    try{
      if(mapPointSelection && mapPointSelection.length > 0)
      {
        if(mapPointSelection[0].type === "PU")
        {
          setPickupAddr(mapPointSelection[0].address);
          pickLatLng.current = mapPointSelection[0].latlng;
          let filteredMapMarkers = mapData.filter((item)=>{
            return item.Type === "DO";
          });
          // console.log(filteredMapMarkers);
          filteredMapMarkers.push(
            {lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: mapPointSelection[0].address
            },
          );
          setMapData(filteredMapMarkers);
          if(dropLatLng.current !== "")
          {
            setIsVSSelectionDisabled(true);
            setIsSchTimeFieldDisabled(false);
            wrapperHandleAddressDetails("PU", mapPointSelection[0].address);
            //handleAddressDetails("PU", mapPointSelection[0].address);
            wrapperHandleRCZVerification("PU", mapPointSelection[0].address);
            setIsVSSelectionDisabled(false);
          }
        }
        else
        {
          setDropAddr(mapPointSelection[0].address);
          dropLatLng.current = mapPointSelection[0].latlng;
          let filteredMapMarkers = mapData.filter((item)=>{
            return item.Type === "PU";
          });
          filteredMapMarkers.push(
            {lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: mapPointSelection[0].address
            },
          );
          setMapData(filteredMapMarkers);
          if(pickLatLng.current !== "")
          {
            setIsVSSelectionDisabled(true);
            setIsSchTimeFieldDisabled(false);
            wrapperHandleAddressDetails("DO", mapPointSelection[0].address);
            //handleAddressDetails("DO", mapPointSelection[0].address);
            wrapperHandleRCZVerification("DO", mapPointSelection[0].address);
            setIsVSSelectionDisabled(false);
          }
        }
        
        setIsVSSelectionDisabled(false);
        
      }
    }
    catch(err){console.log(err); setIsVSSelectionDisabled(false);}
  }, [mapPointSelection]);

  useEffect(() =>{
    try{
      if(showDynamicModal){
        window.addEventListener('keydown', handleKeyPress);
      }
      else {
        window.removeEventListener('keydown', handleKeyPress);
      }
    }
    catch(err){console.log(err);}
  }, [showDynamicModal]);



  useEffect(() => {
    try{
      if(isFirstRender.current){
        isFirstRender.current = false;
        return;
      }
      if(schTime === "" && bookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "")
      {
        bookBtnRef.current.disabled = false;
      }
        if (schTime === "") {
            if (isValidateRCZCalledFromReset.current == false && pickLatLng.current !== "" && dropLatLng.current !== "") {
                handleValidationMsg();
            }
        }
    }
    catch(err){console.log(err);}
    
  }, [schTime]);
  
  const handleSchTimeBlur = async()=>{
    if (schTime !== "" && schTime.includes(":")) {
      await validateMinScheduleTimeDiffference();
    }
    else{
        if (schTime == "") {
            setIsTimeValidated(true);
            bookBtnRef.current.disabled = false;
        }
        else {
            bookBtnRef.current.disabled = true;
        }
    }
    };

    const schTimeOnClick = async () => {
        try {
            if (bookBtnRef.current.disabled == false) {
                bookBtnRef.current.disabled = true;
            }
        } catch (error) {

        }
    }

    const schTimeOnFocus = async () => {
        try {
            isValidateRCZCalledFromReset.current = false;
            if (bookBtnRef.current.disabled == false) {
                bookBtnRef.current.disabled = true;
            }

            if (schTime == "") {

            }
        } catch (error) {

        }
    }

  const clearSchTime = async() => {
    setSchTime("");
    if(bookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "")
    {
      bookBtnRef.current.disabled = false;
    }
  }
  // useEffect(() => {
  //   try{
  //   if (!enableTimeSelection) {
  //     const id = setInterval(() => {
  //       setSchTime(getCurrentTimeInNY());
  //     }, 1000);
  //     setIntervalId(id); 
  //     return () => clearInterval(id);
  //   } else {
  //     clearInterval(intervalId);
  //   }
  //   }catch(err){console.log(err);}
  // },[enableTimeSelection]);
  // Function to get the current time in New York time zone
  const getCurrentTimeInNY = () => {
    const date = new Date();
    const options = {
      timeZone: 'America/New_York',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  const handleKeyPress = useCallback((event) =>{
    try{
      if (event.key === 'Enter') {
        setShowDynamicModal(false);
      }
    }
    catch(err){console.log(err);}
  }, []);

  const handleMapVSSelected = (data)=>{
    setMapVSSelected(data);
  };

  const handleMapPointSelection = (data)=>{
    
    if(data != undefined && data != null){
      try {
        if(data[0].type == "PU"){
          mapPointPickupSelection.current = data;
        }
        else if(data[0].type == "DO"){
          mapPointDropoffSelection.current = data;
        }
        
      } catch (error) {
        
      }
    }
    setMapPointSelection(data);
  };

  const handleCancelTrip = async(confirmation, type="dispatchTrip")=>{
    try{
      setShowAPILoader(true);
      let data = {
        "ConfirmatinoNo": String(confirmation),
        "TripID": "-1",
        "Status": "Cancelled",
        "Message": "Cancelled by Agent",
        "iModifiedbyAppId": 26,
        "iModifiedByUID": parseInt(loginData.iUserID)
      };
      let response = await APICom.fetchData("ReservationCoreURL","SubmitTripConfirmation", "post", {}, data, xCancelSourceForGrid.current);
      setShowAPILoader(false);
      if(!type.toLowerCase().includes("active"))
      {
        if(response && parseInt(response.data.responseCode) !== 200)
        {
          handleResetAll("func");
          setModalHeaderText("Cancel Trip Error");
          setModalBodyHTML("An issue occured while cancelling the trip, please try again later.");
          setModalFooterHTML(
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
      }
      else
      {
        if(response && parseInt(response.data.responseCode) !== 200)
        {
          setModalHeaderText("Cancel Trip Error");
          setModalBodyHTML("An issue occured while cancelling the trip, please try again later.");
          setModalFooterHTML(
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
        else if(parseInt(response.data.responseCode) === 200)
        {
          setModalHeaderText("Trip Cancelled Successfully");
          setModalBodyHTML("Trip #"+confirmation+" is cancelled.");
          setModalFooterHTML(
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          let filteredData = ActiveTripsTableData.filter((item)=>{
            // console.log(item.iRefId);
            return String(item.iRefId) !== String(confirmation);
          });
          console.log("new data", filteredData);
          setActiveTripsTableData(filteredData);
          setShowDynamicModal(true);
          setActiveTripConfirmation("");
          
        }
      }
      
    }
    catch(err){console.log(err);}
  };

  const handleRemoveRecord = (e)=>{
    try{
      let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
      
      const updatedList = mtsmConfirmationNumList.filter(item=>{
        return item.Confirmation !== e.target.name;
      });
      PersistStorage.save("confirmationsData", updatedList, 999, false);
    }
    catch(err){console.log(err);}
  };

  const handleRejectConfirmation = (e)=>{
    try{
      let eventType = e.target.getAttribute('data-name');
      let Type = "";
      if(eventType && eventType.toLowerCase() === 'cancel')
      {
        Type = "Cancel";
      }
      else
      {
        Type = "Reject";
      }
      setModalHeaderText(Type+" Trip Confirmation");
      setModalBodyHTML(
        <>
          <p className="m-0 user-select-none">
            {"Are you sure to "}{Type.toLowerCase()}{" the trip with following confirmation#?"} 
          </p>
          <p className="m-0 w-100 fw-bold text-center user-select-none">{e.target.name}</p>
        </>
      );
      setModalFooterHTML(
        <>
          <Button variant='dark' name={e.target.name} data-name={eventType} className="border-0" onClick={handleRejectTrip}>
            Yes
          </Button>
          <Button variant='secondary' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            No
          </Button>
        </>
      );
      setShowDynamicModal(true);
    }
    catch(err){console.log(err);}
  };

  const handleRejectTrip = async(e)=>{
    try{
      setShowDynamicModal(false);
      setShowAPILoader(true);
      let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
      console.log("trip got here for rejection: ", (e.target.name));
      let cancelType = e.target.getAttribute('data-name');
      // cancelAPICounterRef.current +=1;
      // if(cancelType && cancelType.toLowerCase() === "cancel")
      // {
      //   for(let l = 0; l < mtsmConfirmationNumList.length; l++)
      //   {
      //     if(String(mtsmConfirmationNumList[l].Confirmation) === String(e.target.name))
      //     {
      //       mtsmConfirmationNumList[l].time = "N/A";
      //       mtsmConfirmationNumList[l].msg = "Routing system timed out";
      //     }
      //   }
      //   PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
      // }
        
      
      let data = {
        "ConfirmatinoNo": String((e.target.name)),
        "TripID": "-1",
        "Status": "Cancelled",
        "Message": (cancelType && cancelType.toLowerCase() === "cancel") ? "Cancelled while booking" : "Cancelled by Agent",
        "iModifiedbyAppId": 26,
        "iModifiedByUID": parseInt(loginData.iUserID)
      };
      let response = await APICom.fetchData("ReservationCoreURL","SubmitTripConfirmation", "post", {}, data, xCancelSourceForGrid.current);
      // console.log(response);
      setShowAPILoader(false);
      if(response && parseInt(response.data.responseCode) === 200)
      {
        // cancelAPICounterRef.current = 0;
        // const updatedList = mtsmConfirmationNumList.filter(item=>{
        //   return item.Confirmation !== (e? e.target.name:tempConfRef.current);
        // });
        // PersistStorage.save("confirmationsData", updatedList, 999, false);
        // console.log("got here with e being:", e.target.name);
        if(cancelType && cancelType.toLowerCase() === "cancel")
        {
          for(let l = 0; l < mtsmConfirmationNumList.length; l ++)
          {
            if(String(mtsmConfirmationNumList[l].Confirmation) === String(e.target.name))
            {
              mtsmConfirmationNumList[l].time = "N/A";
              mtsmConfirmationNumList[l].dropTime = "N/A";
              mtsmConfirmationNumList[l].msg = "Cancelled by Agent";
            }
          }
          PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
        }
        else if(cancelType.toLowerCase() === "reject")
        {
          for(let l = 0; l < mtsmConfirmationNumList.length; l ++)
            {
              if(String(mtsmConfirmationNumList[l].Confirmation) === String(e.target.name))
              {
                mtsmConfirmationNumList[l].time = "N/A";
                mtsmConfirmationNumList[l].dropTime = "N/A";
                mtsmConfirmationNumList[l].msg = "Proposed time rejected by the customer";
              }
            }
            PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
        }
        
        // tempConfRef.current = "";
      }
      else
      {
        for(let l = 0; l < mtsmConfirmationNumList.length; l ++)
        {
          if(String(mtsmConfirmationNumList[l].Confirmation) === String((e.target.name)))
          {
            mtsmConfirmationNumList[l].time = "N/A";
            mtsmConfirmationNumList[l].dropTime = "N/A";
            mtsmConfirmationNumList[l].msg = "Cancellation has failed, please try again";
          }
        }
        PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
        // handleRejectTrip();
      }
      
      // PersistStorage.save("confirmationsData", updatedList, 999, false);
      
    }
    catch(err){console.log(err);}
  };

  // Parsing data
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  const ParseGeoCodedData = (data, Identifier, Index = 0) => {  
    var IndexLocal = 0;
    if (typeof Index == 'undefined') IndexLocal = Index;


    var StreatNum = ""; var route = ""; var Locality = ""; var Admin3 = ""; var Admin2 = ""; var Admin1 = ""; var Country = ""; var PostalCode = "";
    var establishment = ""; var neighborhood = ""; var park = ""; var premise = ""; var subpremise = ""; var sublocality = ""; var intersection = "";

    var StreatNum_short = ""; var route_short = ""; var neighborhood_short = ""; var park_short = ""; var premise_short = ""; var subpremise_short = ""; var intersection_short = "";
    var FormatedAddress = "";
      data.address_components.forEach((component) => {
        const componentType = component.types[0];
        const longName = component.long_name;
        const shortName = component.short_name;

        switch (componentType) {
            case 'street_number': StreatNum = longName; StreatNum_short = shortName;
                break;
            case 'route': route = longName; route_short = shortName;
                break;
            case 'locality': Locality = longName;
                break;
            case 'administrative_area_level_3': Admin3 = longName;
                break;
            case 'administrative_area_level_2': Admin2 = longName;
                break;
            case 'administrative_area_level_1': Admin1 = shortName;
                break;
            case 'country': Country = longName;
                break;
            case 'postal_code': PostalCode = longName;
                break;
            case 'establishment': establishment = longName;
                break;
            case 'neighborhood': neighborhood = longName; neighborhood_short = shortName;
                break;
            case 'park': park = longName; park_short = shortName;
                break;
            case 'premise': premise = longName; premise_short = shortName;
                break;
            case 'subpremise': subpremise = longName; subpremise_short = shortName;
                break;
            case 'sublocality': sublocality = longName;
                break;
            case 'intersection': intersection = longName; intersection_short = shortName;
                break;
            default: break;
        }

    });
    FormatedAddress = data.formatted_address;
    if (!PostalCode) {
    }
    if (Admin1.trim() == Country.trim()) {//If it sends country in state, empty the state.
        Admin1 = "";
    }
    var AggregatedStreetAdddr = "";
    AggregatedStreetAdddr = (premise.trim() == "" ? "" : premise + ", ") + (subpremise.trim() == "" ? "" : subpremise + ", ") + (park.trim() == "" ? "" : park + ", ") + ((neighborhood.trim() == "" || route != "" || StreatNum != "") ? "" : neighborhood + ", ") + (intersection.trim() == "" ? "" : intersection + ", ") + StreatNum + " " + route;
    

    try {
        if (FormatedAddress.split(',').length > 0) {

            var StreetAdd = data.formatted_address.split(',')[0];
            if (StreetAdd != "" && StreetAdd.indexOf("&") > -1 && (StreetAdd.indexOf(route) > -1 || StreetAdd.indexOf(StreatNum) > -1 || StreetAdd.indexOf(intersection) > -1 || StreetAdd.indexOf(neighborhood) > -1 || StreetAdd.indexOf(park) > -1 || StreetAdd.indexOf(subpremise) > -1 || StreetAdd.indexOf(premise) > -1
                || StreetAdd.indexOf(route_short) > -1 || StreetAdd.indexOf(StreatNum_short) > -1 || StreetAdd.indexOf(intersection_short) > -1 || StreetAdd.indexOf(neighborhood_short) > -1 || StreetAdd.indexOf(park_short) > -1 || StreetAdd.indexOf(subpremise_short) > -1 || StreetAdd.indexOf(premise_short) > -1)) {
                AggregatedStreetAdddr = StreetAdd;
            }
        }
    } catch (CrashFailSafe) { }
    var isPoiLatLong = false;
    try {
        if (typeof data.placessearchedresult != 'undefined') {
            if (data.placessearchedresult == true) {
                isPoiLatLong = true;
            }
        }
    }
    catch (twa) { }
    var _mapSource = "unkwnSource";
    try {
        if (typeof data.mapSource != 'undefined') {
            _mapSource = data.mapSource;
        }
    } catch (setMapSrcExp) { }
    var ParsedData = {
        "Street": AggregatedStreetAdddr.trim() == "" ? establishment : AggregatedStreetAdddr.trim(),
        "City": (Locality == "") ? Admin2 : Locality,
        "State": (Admin1.toString().toLowerCase() == "maryland") ? 'MD' : Admin1,
        "Zip": PostalCode,
        "Lat": data.geometry.location.lat,
        "Long": data.geometry.location.lng,
        "Address": FormatedAddress,
        "data": data,
        "Country": Country,
        "Identifier": Identifier,
        "isPoiLatLong": isPoiLatLong,
        "UnitNumber": (data.sUnitNumber == undefined || data.sUnitNumber == null) ? "" : data.sUnitNumber,
        "GeocodeSource": _mapSource

    }
    return ParsedData;
};
// ___________________


  const startAffSelectionDropDown = (selectedAffVS)=>{
    try{
      let updatedListofVS = [];
      let filteredSet = new Set();
      selectedAffVS.forEach(item=>{
        if(!filteredSet.has(item.ID))
        {
          updatedListofVS.push(item);
          filteredSet.add(item.ID);
        }
      });

      let userAffiliateArray = Array.isArray(loginData.UserAffiliateList)
      ? loginData.UserAffiliateList
      : loginData.UserAffiliateList.split(',').map(id => id.trim());
  
      console.log(AffiliateData);
      let filteredData = AffiliateData.filter((item, index)=>{
        if(userAffiliateArray.includes(String(item.AffiliateID)) && parseInt(item.iTransType) === 2)
        {
          return true;
        }
        else
        {
          return false;
        }
      });
      let affiliateOptionsHTML = filteredData.map(function(item, index){
        return (
          <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
        );
      });
      let sortedListofVS = updatedListofVS.sort((a,b)=>{
        return a.Location.localeCompare(b.Location);
      });
      let virtualStopOptionsHTML = sortedListofVS.map(function(item, index){
        let LatLng = String(item.vLatitude) +","+ String(item.vLongitude);
        return(
          <option key={index} value={item.ID} data-name={item.Street} data-virtual={LatLng}>{item.Location}</option>
        );
      });
      if(affiliateOptionsHTML && affiliateOptionsHTML.length === 1)
      {
        setSelectedAff(filteredData[0].AffiliateID);
      }
      setVirtualStopDropDownHTML(virtualStopOptionsHTML);
      setAffiliateDropDownHTML(affiliateOptionsHTML); 
      for(let j = 0; j < updatedListofVS.length; j++)
      {
        if(rowData.current && rowData.current.length > 0 && rowData.current[0].PickupAddress.includes(updatedListofVS[j].Location))
        {
          setPickupVirtualStop({...pickupVirtualStop, value:updatedListofVS[j].ID, name:updatedListofVS[j].Location});
        }
        if(rowData.current && rowData.current.length > 0 && rowData.current[0].Destination.includes(updatedListofVS[j].Location))
        {
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:updatedListofVS[j].ID, name:updatedListofVS[j].Location});
        }
      }
      
    }
    catch(err){console.log(err);}
  };


  const handleCloseEditTrip = () =>{
    try{
      setShowEditTripDialog(false);
      window.close();
      // props.setShowEditDialog(false);
    }
    catch(err)
    {
      console.log(err);
    }
  };

  const handleSearchCustomerName = async()=>{
    try{
      clientNameCheckRef.current.blur();
      setSearchButtonValidation("");
      if(riderNameCheck.length > 0)
      {
        searchClientBtnRef.current.disabled = true;
        let selectedFamilyData = AffiliateData.filter((item)=>{
          if(parseInt(item.AffiliateID) === parseInt(selectedAff))
          {
            return true;
          }
        });

        let data = {
          "searchCriteria": "CustomerName",
          "searchText": riderNameCheck,
          "bActiveRecords": true,
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
          "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
        };
        setModalHeaderText("Client Info Processing");
        setModalBodyHTML("Please wait...");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
          </>
        );
        setShowDynamicModal(true);
        setModalClass("d-none");
        setShowAPILoader(true);
        let response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
        if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
        {
          searchClientBtnRef.current.disabled = false;
          let clientInfo = JSON.parse(response.data.responseJSON);
          setSearchButtonValidation("");
          if(clientInfo.length > 1)
          {
            clientIndexRef.current = 0;
            setModalHeaderText("Client Info Selection");
            setModalBodyHTML(
              <>
                <p className="m-0 user-select-none">
                  {"Please select the desired client from the following options with provided name: "}
                  <span className="fw-bold text-center user-select-none">{"("+riderNameCheck+")"}</span> 
                </p>
                <Row className="m-0 justify-content-center">
                  <select className='text-center m-1 px-1 w-50 overflow-hidden' style={{textOverflow:"ellipsis"}}
                    onChange={(e)=>{clientIndexRef.current = e.target.value}}
                  >
                    <option disabled hidden value={999}>{"Select Client"}</option>
                    {clientInfo.map(function(item, index){
                      return(
                        <option key={index} value={index}>{item.FirstName+" "+item.LastName + (item.HomePhone.length === 0 ? "":" ("+item.HomePhone+")")}</option>
                      );
                    })}
                  </select>
                </Row>
              </>
            );
            setModalFooterHTML(
              <>
                <Button variant='dark' className="border-0" onKeyDown={(e)=>{
                    if(e.key === "Enter"){console.log("it got here!");}
                  }} onClick={()=>{handleClientInfoGeneration(clientInfo[parseInt(clientIndexRef.current)]);}}>
                  OK
                </Button>
              </>
            );
            setShowDynamicModal(true);
            setModalClass("");
            setShowAPILoader(false);
          }
          else
          {
            setModalClass("");
            setShowDynamicModal(false);
            setShowAPILoader(false);
            handleClientInfoGeneration(clientInfo[0]);
          }
        }
        else
        {
          setModalClass("");
          setShowDynamicModal(false);
          setShowAPILoader(false);
          searchClientBtnRef.current.disabled = false;
          if(response && response.error === "") //no client found
          {
            let responseJSON = JSON.parse(response.data.responseJSON);
            setSearchButtonValidation("No client record found");
            riderNameRef.current.focus();
          }
          else
          {
            setSearchButtonValidation(response.error);
            // clientNameCheckRef.current.focus();
          }
        }
      }
      else
      {
        setSearchButtonValidation("Please enter the complete name");
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientNameChange = async(e)=>{
    try{
      
      setRiderNameCheck(e.target.value);
      let input = e.target.value;
      if(input.trim().length >= 3)
      {
        let selectedFamilyData = AffiliateData.filter((item)=>{
          if(parseInt(item.AffiliateID) === parseInt(selectedAff))
          {
            return true;
          }
        });

        let data = {
          "searchCriteria": "CustomerName",
          "searchText": input,
          "bActiveRecords": true,
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
          "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
        };
        if(input != "")
        {
          let response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
          // console.log(JSON.parse(response.data.responseJSON));
          if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
          {
            let clientInfo = JSON.parse(response.data.responseJSON);
            liClientNameRefs.current = [];
            if(clientInfo.length > 0)
            {
              let suggestionsHTML = clientInfo.map(function(item, index){
                liClientNameRefs.current[index] = React.createRef(); // Create a ref for each <li>
                let formattedName = item.FirstName.length === 0? (item.LastName+(item.HomePhone.length === 0 ? "" :" ("+item.HomePhone+")")) : 
                  item.FirstName +", "+ item.LastName + (item.HomePhone.length === 0 ? "" :" ("+item.HomePhone+")");
                return(
                  <li ref={liClientNameRefs.current[index]} className="border-bottom text-nowrap overflow-hidden px-1 addressSelectionRow" 
                    onFocus={()=>{focusedSuggestionCheckClientName.current = true;}}
                    style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckClientName.current = false;}} onKeyDown={(e)=>{
                        if(e.key === 'ArrowDown')
                        {
                          e.preventDefault();
                          if(liClientNameRefs.current.length > 0)
                          {
                            setHighlightedIndex((prevIndex) => {
                              const newIndex = (prevIndex + 1) % liClientNameRefs.current.length;
                              liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                              return newIndex;
                            });
                          }
                        }
                        else if (e.key === 'ArrowUp') {
                          e.preventDefault();
                          if(liClientNameRefs.current.length > 0)
                          {
                            setHighlightedIndex((prevIndex) => {
                              const newIndex = (prevIndex - 1 + liClientNameRefs.current.length) % liClientNameRefs.current.length;
                              liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                              return newIndex;
                            });
                          }
                        }
                        else if(e.key === "Enter")
                        {
                          setInputSuggestionListClientName("");
                          handleClientInfoGeneration(clientInfo[index]);
                        }
                    }}
                    onClick={()=>{handleClientInfoGeneration(clientInfo[index]);}} key={index} value={formattedName}
                  >
                    {formattedName}
                  </li>
                );
              });
              setInputSuggestionListClientName(suggestionsHTML);
            }
          }
          else
          {
            setInputSuggestionListClientName("");
          }
        }
        else
        {
          setInputSuggestionListClientName("");
          // clientNameCheckRef.current.focus();
        }
      }
      else if(input.trim().length === 0)
      {
        setInputSuggestionListClientName("");
      }
      else
      {
        setInputSuggestionListClientName("");
      }
    }
    catch(err){console.log(err);}
  };

  const handleSearchCustomerPhone = async()=>{
    try{
      clientNameCheckRef.current.blur();
      phoneRef.current.blur();
      setSearchButtonValidation("");
      if(phone && phone.length === 12)
      {
        // phoneRef.current.blur();
        searchClientBtnRef.current.disabled = true;
        let selectedFamilyData = AffiliateData.filter((item)=>{
          if(parseInt(item.AffiliateID) === parseInt(selectedAff))
          {
            return true;
          }
        });
        let areaCode = phone.replace("+1","").substring(0,3);
        let firstPart = phone.replace("+1","").substring(3,6);
        let secondPart = phone.replace("+1","").substring(6,10);
        let data = {
          "searchCriteria": "CustomerPhone",
          "searchText": (areaCode+"-"+firstPart+"-"+secondPart),
          "bActiveRecords": true,
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
          "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
        };
        setModalHeaderText("Client Info Processing");
        setModalBodyHTML("Please wait...");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
          </>
        );
        setShowDynamicModal(true);
        setModalClass("d-none");
        setShowAPILoader(true);
        let response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
        if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
        {
          searchClientBtnRef.current.disabled = false;
          let clientInfo = JSON.parse(response.data.responseJSON);
          setSearchButtonValidation("");
          // console.log(clientInfo);
          if(clientInfo.length > 1)
          {
            clientIndexRef.current = 0;
            setModalHeaderText("Client Info Selection");
            setModalBodyHTML(
              <>
                <p className="m-0 user-select-none">
                  {"Please select the desired client from the following options with provided phone number: "}
                  <span className="fw-bold text-center user-select-none">{("("+areaCode+") "+firstPart+"-"+secondPart)}</span> 
                </p>
                <Row className="m-0 justify-content-center">
                  <select className='text-center m-1 px-1 w-50 overflow-hidden' style={{textOverflow:"ellipsis"}}
                    onChange={(e)=>{clientIndexRef.current = e.target.value}}
                  >
                    <option disabled hidden value={999}>{"Select Client"}</option>
                    {clientInfo.map(function(item, index){
                      return(
                        <option key={index} value={index}>{item.FirstName+" "+item.LastName}</option>
                      );
                    })}
                  </select>
                </Row>
                {/* <p className="m-0 w-100 fw-bold text-center user-select-none"></p> */}
              </>
            );
            setModalFooterHTML(
              <>
                <Button variant='dark' className="border-0" onClick={()=>{handleClientInfoGeneration(clientInfo[parseInt(clientIndexRef.current)]);}}>
                  OK
                </Button>
              </>
            );
            setShowDynamicModal(true);
            setModalClass("");
            setShowAPILoader(false);
          }
          else
          {
            setModalClass("");
            setShowDynamicModal(false);
            setShowAPILoader(false);
            handleClientInfoGeneration(clientInfo[0]);
          }
        }
        else
        {
          setModalClass("");
          setShowDynamicModal(false);
          setShowAPILoader(false);
          searchClientBtnRef.current.disabled = false;
          if(response && response.error === "") //no client found
          {
            let responseJSON = JSON.parse(response.data.responseJSON);
            // console.log(responseJSON);
            setSearchButtonValidation("No client record found");
            riderNameRef.current.focus();
            //setModalHeaderText("Search Client Data Error");
            //setModalBodyHTML(responseJSON.message);
            // setModalFooterHTML(
            //   <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            //     OK
            //   </Button>
            // );
            // setShowDynamicModal(true);
          }
          else
          {
            setSearchButtonValidation(response.error);
            // clientNameCheckRef.current.focus();
            // setModalHeaderText("Search Client Data Error");
            // setModalBodyHTML(response.error);
            // setModalFooterHTML(
            //   <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            //     OK
            //   </Button>
            // );
            // setShowDynamicModal(true);
          }
        }
      }
      else
      {
        // clientNameCheckRef.current.focus();
        setSearchButtonValidation("Please enter the complete phone number/name");
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientInfoGeneration = async(data)=>{
    try{
      if(data && data !== undefined)
      {
        searchedClientID.current = data.Id;
      }
      console.log("generation: ",data);
      setRiderName(data.FirstName+" "+data.LastName);
      riderNameRef.current.focus();
      if(riderNameCheck.length > 0)
      {
        setPhone(("+1"+data.HomePhone.replaceAll("-","")));
        phoneRef.current.style.borderColor = "";
        phoneRef.current.style.borderWidth = "";
      }
      setCallBackPhone(("+1"+data.HomePhone.replaceAll("-","")));
      // setPhone(("+1"+data.HomePhone.replaceAll("-","")));
      setClientSummary({...clientSummary, totalCancels:parseInt(data.TotalCancelled), lastCall: String(data.LastCallDate)});
      setPassengerTypeCount({...passengerTypeCount, totalWC:parseInt(data.iWheelChairCount)});
      setModalHeaderText("Existing Client Rides Processing");
      setModalBodyHTML("Please wait...");
      setModalFooterHTML(
        <>
          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            OK
          </Button>
        </>
      );
      setShowDynamicModal(true);
      setModalClass("d-none");
      setShowAPILoader(true);
      setClientInfo(data);
      let activeTripsData = {
        "searchCriteria": "CustomerID",
        "searchText": String(data.Id),
        "iATSPID": selectedAff ? parseInt(selectedAff) : -1
      };
      let response = await APICom.fetchData("ReservationCoreURL","GetExistingRides", "post", {}, activeTripsData, xCancelSourceForGrid.current);
      console.log("Existing rides data: ", response);
      setShowAPILoader(false);
      if(response && response.error === "")
      {
        if(parseInt(response.data.responseCode) === 200)
        {
          setShowClientActiveTripsModal(true);
          let responseJSON = JSON.parse(response.data.responseJSON);
          console.log(responseJSON);
          setActiveTripsTableData(responseJSON);
          setShowDynamicModal(false);
          setModalClass("");
        }
        else
        {
          // let responseJSON = JSON.parse(response.data.responseJSON);
          // setModalHeaderText("Active Trips Not Found");
          // setModalBodyHTML(<p className="m-0">{"No active trips found for the client: "}<span className="fw-bold">{data.FirstName+" "+data.LastName}</span></p>);
          // setModalFooterHTML(
          //   <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
          //     OK
          //   </Button>
          // );
          setModalClass("");
          setShowDynamicModal(false);
          setInputSuggestionListClientName("")
          setSearchButtonValidation("No active trips found");
          setTimeout(() => {
            setSearchButtonValidation("");
          }, 5000);
        }
      }
      else
      {
        // setModalHeaderText("Active Trips Data Error");
        // setModalBodyHTML(response.error);
        // setModalFooterHTML(
        //   <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
        //     OK
        //   </Button>
        // );
        setModalClass("");
        setShowDynamicModal(false);
        setSearchButtonValidation("An error occured when retrieving active trips");
        setTimeout(() => {
          setSearchButtonValidation("");
        }, 5000);
      }
      let ClientAddrData = {
        "clientID": String(data.Id),
        "affiliateID": selectedAff ? String(selectedAff) : -1
      };
      let recentAddresses = await APICom.fetchData("ReservationCoreURL","GetHistoricRides", "post", {}, ClientAddrData, xCancelSourceForGrid.current);
      if(recentAddresses && recentAddresses.error === "")
      {
        if(parseInt(recentAddresses.data.responseCode) === 200)
        {
          let recentAddrArray = JSON.parse(recentAddresses.data.responseJSON);
          if(recentAddrArray.length > 0)
          {
            setRecentAddresses(recentAddrArray);
          }
        }
      }
    }
    catch(err){console.log(err);}
  };
  const handleClientInfoTableOpen = ()=>{
    try{
      console.log("table reload");
    }
    catch(Err){console.log(Err);}
  };

  const handleValidationMsg = (e) => {
    setShowDynamicModal(false);
    if(dropAddrVirtualStop != undefined && dropAddrVirtualStop != null && dropAddrVirtualStop?.value != "" &&  dropAddrVirtualStop?.value != null
    && (pickupVirtualStop != undefined && pickupVirtualStop != null && pickupVirtualStop?.value != "" &&  pickupVirtualStop?.value != null )){
      setShowAPILoader(true);
      wrapperHandleRCZVerification("DO", dropAddrVirtualStop.name);
    }
  }

  useEffect(() =>{
    
    if(doVSValueChanged.current != dropAddrVirtualStop.name){
      doVSValueChanged.current = dropAddrVirtualStop.name
    }
    if(pickLatLng.current !== "" && doVSCallValidation.current == true)
    {
      async function CallFunctionsForDOValidations() {
        // You can await here
        setIsVSSelectionDisabled(true);
        await handleAddressDetails("DO", dropAddrVirtualStop.name);
        await handleRCZVerification("DO", dropAddrVirtualStop.name, " ");
        doVSCallValidation.current = false;
        setIsVSSelectionDisabled(false);
        // ...
      }
      CallFunctionsForDOValidations();
    }

  },[dropAddrVirtualStop])

  useEffect(() =>{
    if(puVSValueChanged.current != pickupVirtualStop.name){
      puVSValueChanged.current = pickupVirtualStop.name
    }
    if(dropLatLng.current !== "" && puVSCallValidation.current == true)
    {
      async function CallFunctionsForValidation(){
        setIsVSSelectionDisabled(true);
        await handleAddressDetails("PU", pickupVirtualStop.name);
        await handleRCZVerification("PU", pickupVirtualStop.name, " ");
        puVSCallValidation.current = false;
        setIsVSSelectionDisabled(false);
      }
      CallFunctionsForValidation();
    }
  },[pickupVirtualStop])

  const validateMinScheduleTimeDiffference = async(_schTime = undefined) => {
    try 
    {
        let tempSchTime = schTime;
        if (_schTime != undefined) {
            setSchTime(_schTime);
            tempSchTime = _schTime;
        }
      setShowAPILoader(true);
      let ScheduleTripMinTimeDiff = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "ScheduleTripMinTimeDiff")).value);
      if (ScheduleTripMinTimeDiff != undefined) {
        const options = {timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: 'numeric' };
        const currDate = new Date().toLocaleDateString('en-US', options);
        let data = {
            "PickupDateTime": currDate + " " + tempSchTime,
            "MinSchTimeDiff": ScheduleTripMinTimeDiff
        }
        let response = await APICom.fetchData("ReservationCoreURL","ValiateMinScheduleTimeDifference", "post", {}, data, xCancelSourceForGrid.current);
        console.log("booking response: ", response);
        if(response && response.error.length === 0)
        {
          if(response.data.responseCode == 400)
          {
            setIsTimeValidated(false);
            bookBtnRef.current.disabled = true;
            setModalHeaderText("Schedule Date & Time");
            setModalBodyHTML(response.data.responseMessage);
            setModalFooterHTML(
              <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setShowDynamicModal(true);
            setModalClass("");
          }
          else if(response.data.responseCode == 200 && pickLatLng.current !== "" && dropLatLng.current !== "")
          {
            setIsTimeValidated(true);
            bookBtnRef.current.disabled = false;
            handleValidationMsg();
          }
        }
        setShowAPILoader(false);
      }
    } 
    catch (error) {    
      setIsTimeValidated(false);
      bookBtnRef.current.disabled = true;
      setShowAPILoader(false);
    }
  };

  const prepareDataForUserEnteredPickupAddress = () => {
    
    let pickupData = {  
      "reqpustreet": "",
      "reqpucity": "",
      "reqpustate": "",
      "reqpuzip": "",
      "reqpuzone": "",
      "reqpulat": "",
      "reqpulong": "",
      "reqpustopname": ""}
    try {

      if(mapPointPickupSelection?.current != undefined && mapPointPickupSelection?.current != null){
        
        //City
        if(mapPointPickupSelection.current.City != undefined && mapPointPickupSelection.current.City != null){
          pickupData.reqpucity = mapPointPickupSelection.current.City;
        }
        else if(mapPointPickupSelection.current.PUCity != undefined && mapPointPickupSelection.current.PUCity != null){
          pickupData.reqpucity = mapPointPickupSelection.current.PUCity;
        }

        //State
        if(mapPointPickupSelection.current.State != undefined && mapPointPickupSelection.current.State != null){
          pickupData.reqpustate = mapPointPickupSelection.current.State;
        }
        else if(mapPointPickupSelection.current.PUState != undefined && mapPointPickupSelection.current.PUState != null){
          pickupData.reqpustate = mapPointPickupSelection.current.PUState;
        }

        //Street
        if(mapPointPickupSelection.current.Street != undefined && mapPointPickupSelection.current.Street != null){
          pickupData.reqpustreet = mapPointPickupSelection.current.Street;
        }
        else if(mapPointPickupSelection.current.PUAddress != undefined && mapPointPickupSelection.current.PUAddress != null){
          pickupData.reqpustreet = mapPointPickupSelection.current.PUAddress;
        }

        //Zip
        if(mapPointPickupSelection.current.Zip != undefined && mapPointPickupSelection.current.Zip != null){
          pickupData.reqpuzip = mapPointPickupSelection.current.Zip;
        }
        else if(mapPointPickupSelection.current.PUZip != undefined && mapPointPickupSelection.current.PUZip != null){
          pickupData.reqpuzip = mapPointPickupSelection.current.PUZip;
        }

        //Lat
        if(mapPointPickupSelection.current.Lat != undefined && mapPointPickupSelection.current.Lat != null){
          pickupData.reqpulat = mapPointPickupSelection.current.Lat;
        }
        else if(mapPointPickupSelection.current.PULat != undefined && mapPointPickupSelection.current.PULat != null){
          pickupData.reqpulat = mapPointPickupSelection.current.PULat;
        }

        //Lng
        if(mapPointPickupSelection.current.Long != undefined && mapPointPickupSelection.current.Long != null){
          pickupData.reqpulong = mapPointPickupSelection.current.Long;
        }
        else if(mapPointPickupSelection.current.PULong != undefined && mapPointPickupSelection.current.PULong != null){
          pickupData.reqpulong = mapPointPickupSelection.current.PULong;
        }
      }
    } catch (error) {
      
    }
    return pickupData;
  }

  const prepareDataForUserEnteredDropoffAddress = () => {
    let dropoffData = { 
      "reqdostreet": "",
      "reqdocity": "",
      "reqdostate": "",
      "reqdozip": "",
      "reqdozone": "",
      "reqdolat": "",
      "reqdolong": "",
      "reqdostopname": ""}
    try {

      if(mapPointDropoffSelection?.current != undefined && mapPointDropoffSelection?.current != null){
        
        //City
        if(mapPointDropoffSelection.current.City != undefined && mapPointDropoffSelection.current.City != null){
          dropoffData.reqdocity = mapPointDropoffSelection.current.City;
        }
        else if(mapPointDropoffSelection.current.DOCity != undefined && mapPointDropoffSelection.current.DOCity != null){
          dropoffData.reqdocity = mapPointDropoffSelection.current.DOCity;
        }

        //State
        if(mapPointDropoffSelection.current.State != undefined && mapPointDropoffSelection.current.State != null){
          dropoffData.reqdostate = mapPointDropoffSelection.current.State;
        }
        else if(mapPointDropoffSelection.current.DOState != undefined && mapPointDropoffSelection.current.DOState != null){
          dropoffData.reqdostate = mapPointDropoffSelection.current.DOState;
        }

         //Street
        if(mapPointDropoffSelection.current.Street != undefined && mapPointDropoffSelection.current.Street != null){
          dropoffData.reqdostreet = mapPointDropoffSelection.current.Street;
        }
        else if(mapPointDropoffSelection.current.DOAddress != undefined && mapPointDropoffSelection.current.DOAddress != null){
          dropoffData.reqdostreet = mapPointDropoffSelection.current.DOAddress;
        }

        //Zip
        if(mapPointDropoffSelection.current.Zip != undefined && mapPointDropoffSelection.current.Zip != null){
          dropoffData.reqdozip = mapPointDropoffSelection.current.Zip;
        }
        else if(mapPointDropoffSelection.current.DOZip != undefined && mapPointDropoffSelection.current.DOZip != null){
          dropoffData.reqdozip = mapPointDropoffSelection.current.DOZip;
        }

        //Lat
        if(mapPointDropoffSelection.current.Lat != undefined && mapPointDropoffSelection.current.Lat != null){
          dropoffData.reqdolat = mapPointDropoffSelection.current.Lat;
        }
        else if(mapPointDropoffSelection.current.DOLat != undefined && mapPointDropoffSelection.current.DOLat != null){
          dropoffData.reqdolat = mapPointDropoffSelection.current.DOLat;
        }

        //Lng
        if(mapPointDropoffSelection.current.Long != undefined && mapPointDropoffSelection.current.Long != null){
          dropoffData.reqdolong = mapPointDropoffSelection.current.Long;
        }
        else if(mapPointDropoffSelection.current.DOLong != undefined && mapPointDropoffSelection.current.DOLong != null){
          dropoffData.reqdolong = mapPointDropoffSelection.current.DOLong;
        }
      }
    } catch (error) {
      
    }
    return dropoffData;
  }


  const handleCreateUpdateTrip = async(e)=>{
      try {
        if (zones == "") {
            bookBtnRef.current.disabled = true;
            setModalHeaderText("No Zones Found");
            setModalBodyHTML("Please re-enter the addresses");
            setModalFooterHTML(
                <Button variant='secondary' className="border-0" onClick={() => setShowDynamicModal(false)}>
                    OK
                </Button>
            );
            setModalClass("");
            setShowDynamicModal(true);
            return;
        }

      if(isTimeValidated == false)
      {
        await validateMinScheduleTimeDiffference();
      }
      if(isTimeValidated == true)
      {
        sethandlePageProgressBar("calltaker");
        if(passengerTypeCount.total === 0)
        {
          setModalHeaderText("Information Required");
          setModalBodyHTML("Total passenger count can not be 0.");
          setModalFooterHTML(
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setShowAPILoader(false);
        }
        else
        {
          if(riderName.length >= 4 && phone && phone.length === 12)
          {
            if(e.target.textContent.toLowerCase() === "update")
            {
      
            }
            else if(e.target.textContent.toLowerCase() === "book")//create
            {
              setModalHeaderText("Booking In Progress");
              setModalBodyHTML("Trip is being booked, please wait.");
              setModalFooterHTML("");
              setModalClass("d-none");
              setShowAPILoader(true);
              setShowDynamicModal(true);
              bookBtnRef.current.disabled = true;
              const options = {timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: 'numeric' };
              const currDate = new Date().toLocaleDateString('en-US', options);
              // Get the current time
              const currentTime = new Date();
              let addedMinutes = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value)/60;
              let combinedDataAddedTime = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value;
              // Add 10 minutes to the current time
              currentTime.setMinutes(currentTime.getMinutes() + addedMinutes);
    
              // Convert the updated time to a locale time string
              const updatedTime = currentTime.toLocaleTimeString();
              console.log(pickupAddr, " this is drop: ", dropAddr, " this is loginData: ", loginData);
              let areaCode = phone.replace("+1","").substring(0,3);
              let firstPart = phone.replace("+1","").substring(3,6);
              let secondPart = phone.replace("+1","").substring(6,10);
              // loginData.vDisplayName.split(", ")[1]  currDate + " " + updatedTime
              //(JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value
              // console.log(rczVerifData);
              let userEnteredPickupAddress = null;
              try {
                userEnteredPickupAddress = prepareDataForUserEnteredPickupAddress();
              } catch (error) {
              }
              if(userEnteredPickupAddress.reqpustreet == null || userEnteredPickupAddress.reqpustreet == "")
              {
                userEnteredPickupAddress.reqpustreet = pickupAddr;
              }
        
              if(pickupVirtualStop?.value != undefined && pickupVirtualStop?.value != null && pickupVirtualStop?.value != ""){
                try {
                  if(userEnteredPickupAddress?.reqpucity == "" || userEnteredPickupAddress?.reqpucity == undefined && userEnteredPickupAddress?.reqpucity == null)
                  {
                    userEnteredPickupAddress.reqpucity = VirtualStopsData.filter(p => p.ID == pickupVirtualStop.value)[0].City;
                  }
        
                  if(userEnteredPickupAddress?.reqpustate == "" || userEnteredPickupAddress?.reqpustate == undefined && userEnteredPickupAddress?.reqpustate == null)
                  {
                    userEnteredPickupAddress.reqpustate = VirtualStopsData.filter(p => p.ID == pickupVirtualStop.value)[0].State;
                  }
        
                  if(userEnteredPickupAddress?.reqpuzip == "" || userEnteredPickupAddress?.reqpuzip == undefined && userEnteredPickupAddress?.reqpuzip == null)
                  {
                    userEnteredPickupAddress.reqpuzip = VirtualStopsData.filter(p => p.ID == pickupVirtualStop.value)[0].Zipcode;
                  }
                  
                } catch (error) {
                  
                }
              }
        
              let userEnteredDropoffAddress = null;
              try {
                userEnteredDropoffAddress = prepareDataForUserEnteredDropoffAddress();
              } catch (error) {
              }
        
              if(userEnteredDropoffAddress.reqdostreet == null || userEnteredDropoffAddress.reqdostreet == "")
              {
                userEnteredDropoffAddress.reqdostreet = dropAddr;
              }
        
        
              if(dropAddrVirtualStop?.value != undefined && dropAddrVirtualStop?.value != null && dropAddrVirtualStop?.value != ""){
                try {
                  if(userEnteredDropoffAddress?.reqdocity == "" || userEnteredDropoffAddress?.reqdocity == undefined && userEnteredDropoffAddress?.reqdocity == null)
                  {
                    userEnteredDropoffAddress.reqdocity = VirtualStopsData.filter(p => p.ID == dropAddrVirtualStop.value)[0].City;
                  }
        
                  if(userEnteredDropoffAddress?.reqdostate == "" || userEnteredDropoffAddress?.reqdostate == undefined && userEnteredDropoffAddress?.reqdostate == null)
                  {
                    userEnteredDropoffAddress.reqdostate = VirtualStopsData.filter(p => p.ID == dropAddrVirtualStop.value)[0].State;
                  }
        
                  if(userEnteredDropoffAddress?.reqdozip == "" || userEnteredDropoffAddress?.reqdozip == undefined && userEnteredDropoffAddress?.reqdozip == null)
                  {
                    userEnteredDropoffAddress.reqdozip = VirtualStopsData.filter(p => p.ID == dropAddrVirtualStop.value)[0].Zipcode;
                  }
                  
                } catch (error) {
                  
                }
        
              }
              



              let data = {
                "id": "-1",
                "Ta01": (combinedDataAddedTime? combinedDataAddedTime:0),
                "TravelMinutes": walkDistance.PUDuration,
                "referenceId": "",
                "linkedRideIds": [],
                "transportationProviderId": "1312501",
                "scheduledDate": schTime !== "" ? currDate:"01/01/1900", 
                "appointmentTime": "01/01/1900 00:00:00",
                "isPredictive" : "true",
                "bCheckServiceHours": "true",
                "iCreatedByAppID": "26",
                "iCreatedUserId": String(loginData.iUserID),
                "additionalPassengers": {
                    "attendants": 0,
                    "escorts": 0
                },
                "willCall": false,
                "billableAmount": null,
                "billableMiles": parseFloat(clientSummary.tripDistance),
                "assistanceNeeds": [],
                "billingRequired": true,
                "levelOfService": "A",
                "levelOfServiceDescription": "Ambulatory",
                "levelOfServiceGroup": "Ambulatory",
                "unableToSign": false,
                "signatureRequired": true,
                "additionalProperties": {
                    "condition": null,
                    "carseats": 0,
                    "copay": parseFloat(clientSummary.TripFare),
                    "member_number": null,
                    "ordering_medical_provider_name": null,
                    "ordering_medical_provider_npi": null,
                    "prior_auth_num": null
                },
                "rider": {
                    "id": searchedClientID.current,
                    "firstName": riderName === "" ? loginData.vDisplayName.split(", ")[1] : riderName.trim().split(" ")[0],
                    "middleName": "",
                    "lastName": riderName === "" ? loginData.vDisplayName.split(", ")[0] : riderName.trim().split(" ")[1],
                    "dateOfBirth": "1974-09-19",
                    "gender": "M",
                    "weight": 0,
                    "phone": areaCode+"-"+firstPart+"-"+secondPart,
                },
                "pickup": {
                    "address": {
                        "addressLine1": (rczVerifData.pudoNearbyVS.pvs.street.includes(",")?rczVerifData.pudoNearbyVS.pvs.street.split(", ")[0]:rczVerifData.pudoNearbyVS.pvs.street),
                        "addressLine2": "",
                        "city": rczVerifData.pudoNearbyVS.pvs.city,
                        "county": "",
                        "state": rczVerifData.pudoNearbyVS.pvs.state,
                        "zipCode": rczVerifData.pudoNearbyVS.pvs.zip,
                        "latitude": parseFloat(pickLatLng.current.split(",")[0]),
                        "longitude": parseFloat(pickLatLng.current.split(",")[1]),
                        "stopname":pickupVirtualStop.name,
                        "reqpustreet": userEnteredPickupAddress?.reqpustreet != null ? userEnteredPickupAddress.reqpustreet : "",
                        "reqpucity": userEnteredPickupAddress?.reqpucity != null ? userEnteredPickupAddress.reqpucity : "",
                        "reqpustate": userEnteredPickupAddress?.reqpustate != null ? userEnteredPickupAddress.reqpustate : "",
                        "reqpuzip": userEnteredPickupAddress?.reqpuzip != null ? userEnteredPickupAddress.reqpuzip : "",
                        "reqpuzone": zones,
                        "reqpulat": pickLatLng.current.split(",")[0],
                        "reqpulong":pickLatLng.current.split(",")[1],
                        "reqpustopname": pickupVirtualStop.name,
                    },
                    "scheduledTime": schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00",
                    "name": "",
                    "comments": pickExtraInfo,
                    "phone": {
                        "number": areaCode+"-"+firstPart+"-"+secondPart,
                        "ext": 1
                    }
                },
                "dropoff": {
                    "address": {
                        "addressLine1": (rczVerifData.pudoNearbyVS.dvs.street.includes(",")?rczVerifData.pudoNearbyVS.dvs.street.split(", ")[0]:rczVerifData.pudoNearbyVS.dvs.street),
                        "addressLine2": "",
                        "city": rczVerifData.pudoNearbyVS.dvs.city,
                        "county": "",
                        "state": rczVerifData.pudoNearbyVS.dvs.state,
                        "zipCode": rczVerifData.pudoNearbyVS.dvs.zip,
                        "latitude": parseFloat(dropLatLng.current.split(",")[0]),
                        "longitude": parseFloat(dropLatLng.current.split(",")[1]),
                        "stopname":dropAddrVirtualStop.name,
                        "reqdostreet": userEnteredDropoffAddress?.reqdostreet != null ? userEnteredDropoffAddress.reqdostreet : "",
                        "reqdocity": userEnteredDropoffAddress?.reqdocity != null ? userEnteredDropoffAddress.reqdocity : "",
                        "reqdostate": userEnteredDropoffAddress?.reqdostate != null ? userEnteredDropoffAddress.reqdostate : "",
                        "reqdozip": userEnteredDropoffAddress?.reqdozip != null ? userEnteredDropoffAddress.reqdozip : "",
                        "reqdozone": zones,
                        "reqdolat": dropLatLng.current.split(",")[0],
                        "reqdolong": dropLatLng.current.split(",")[1],
                        "reqdostopname": dropAddrVirtualStop.name,
                    },
                    "scheduledTime": schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00",
                    "name": "",
                    "comments": dropExtraInfo,
                    "phone": {
                        "number": areaCode+"-"+firstPart+"-"+secondPart,
                        "ext": 1
                    }
                },
                "webhookURL": "https://api.circulation.com/transit/webhook/atms/",
                "nTotalPassengers":parseInt(passengerTypeCount.total),
                "nTotalWheelChairs":parseInt(passengerTypeCount.totalWC),
                "iServiceAnimalsCount":parseInt(passengerTypeCount.totalSA)
              };
              let response = await APICom.fetchData("ReservationCoreURL","CreateRide", "post", {}, data, xCancelSourceForGrid.current);
              console.log("booking response: ", response);
              if(response && response.error.length === 0)
              {
                if(response.data.responseCode !== 200)
                {
                  setModalHeaderText("Trip Reservation Failed");
                  setModalBodyHTML(response.data.responseMessage);
                  setModalFooterHTML(
                    <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                }
                else
                {
                  //Trip Booked with response JSON
                  let tripID = response.data.id;
                  setModalHeaderText("Trip Booked Successfully");
                  setModalBodyHTML(
                    <>
                      <p className="m-0 user-select-none">
                        {"Please use the following confirmation number to check your trip status: "} 
                      </p>
                      <p className="m-0 w-100 fw-bold text-center user-select-all">{tripID}</p>
                    </>
                  );
                  setModalFooterHTML(
                    <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                  handleResetAll("func");
                  setConfirmationNo(tripID);
                  let oldDataArr = PersistStorage.retrieve('confirmationsData', false);
                  let updatedArr = oldDataArr ? [...oldDataArr, {Confirmation: tripID, time: null, dropTime:null, name:riderName, creationTime: new Date(), msg:"", tripID: ""}] 
                    : [{Confirmation: tripID, time: null, dropTime:null, name:riderName, creationTime: new Date(), msg:"", tripID: ""}];
                  PersistStorage.save('confirmationsData', updatedArr, 999, false);
                  // setSubmitBtnTitle("Update");
                  setTripStatus("Routed");
                  setSchPUTime(null);
                  let MTMSNegotiationHTML = [tripID].map(function(item, index){
                    return(
                      <tr key={index} className="text-center border-bottom border-dark">
                        <td className="border border-dark user-select-none small">{item}</td>
                        <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={""} style={{textOverflow:"ellipsis"}}>
                          {""}
                        </td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={riderName}
                        >{riderName}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={item.msg} 
                          style={{textOverflow:"ellipsis"}}
                        >
                          {item.msg}
                        </td>
                        <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                          <div className="d-flex">
                            <Button variant="secondary" className="d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Remove trip from view"} 
                              onClick={handleRemoveRecord} tabIndex={-1} name={item.ID}>
                              X
                            </Button>
                            {item.time !== "N/A"?<Button variant="danger" className="mx-1 d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Reject scheduled trip"} 
                              onClick={handleRejectTrip} tabIndex={-1} name={item.ID}>
                              Reject
                            </Button>:
                            <Button variant="danger" tabIndex={-1} className="mx-1 d-inline-block p-1 py-0 opacity-0" disabled={item.time === "N/A"} 
                              name={item.ID}>
                              Reject
                            </Button>}
                          </div>
                        </td>
                      </tr>
                    )
                  });
                  setMTSMTableHTML(prevState=>(
                    <>
                      {MTMSNegotiationHTML}
                      {prevState?prevState:""}
                    </>
                  ));
                }
              }
              else
              {
                setModalHeaderText("Trip Reservation Failed");
                setModalBodyHTML(response.error);
                setModalFooterHTML(
                  <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
                bookBtnRef.current.disabled = false;
              }
            }
          }
          else
          {
            if((riderName === "" || riderName.length < 4) && (!phone || phone.length < 12))
            {
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the complete phone number and full name in the provided fields.");
              setModalFooterHTML(
                <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              setModalClass("");
              setShowAPILoader(false);
              riderNameRef.current.style.borderColor = "red";
              riderNameRef.current.style.borderWidth = "3px";
              phoneRef.current.style.borderColor = "red";
              phoneRef.current.style.borderWidth = "3px";
            }
            else if(riderName === "" || riderName.length < 4)
            {
              riderNameRef.current.style.borderColor = "red";
              riderNameRef.current.style.borderWidth = "3px";
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the full name in the highlighted field.");
              setModalFooterHTML(
                <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
            }
            else if(!phone || phone.length < 12)
            {
              phoneRef.current.style.borderColor = "red";
              phoneRef.current.style.borderWidth = "3px";
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the complete phone number in the highlighted field.");
              setModalFooterHTML(
                <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
            }
          }
        }
      }
    }
    catch(err)
    {
      console.log(err);
    }
  };

  const handlePassCountTotal = (e)=>{
    try{
      const regex = /^[0-9\b]+$/;
      if(e.target.value.length > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0")
        {
          e.target.value = tempVal[1];
        }
      }
      if(e.target.name === "ambPass")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 30){e.target.value = 30;}
        setPassengerTypeCount({...passengerTypeCount,ambPass:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCount.totalWC))});
      }
      else if(e.target.name === "totalWC")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 10){e.target.value = 0;}
        setPassengerTypeCount({...passengerTypeCount,totalWC:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCount.ambPass))});
      }
      else if(e.target.name === "totalSA")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 10){e.target.value = 0;}
        setPassengerTypeCount({...passengerTypeCount,totalSA:parseInt(e.target.value), 
          total:(parseInt(passengerTypeCount.ambPass)+ parseInt(passengerTypeCount.totalWC))});
      }
      
    }
    catch(err){console.log(err);}
  };

  const handleVSChange = (e)=>{
    try{
      bookBtnRef.current.disabled = true;
      const selectedIndex = e.target.selectedIndex;
      const selectedOption = e.target.options[selectedIndex];
      const virtualData = selectedOption.getAttribute('data-virtual');
      const name = selectedOption.getAttribute('data-name');
      const nm = selectedOption.textContent;
      if(e.target.title.toLowerCase().includes("pickup"))
      {
        mapPointPickupSelection.current = [];
        if(e.target.value === "PU VS")
        {
          setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
          if(pickLatLng.current === ""){
            setPickupAddr("");
          }
        }
        else
        {
          vsChangeRef.current.type = vsChangeRef.current.type.length === 0 ? "PU ": (vsChangeRef.current.type.includes("PU")? vsChangeRef.current.type:vsChangeRef.current.type+"PU ");

          setPickupVirtualStop({...pickupVirtualStop, value:e.target.value, name:nm});
          if(pickLatLng.current === ""){
            setPickupAddr(name);
            // const selectedIndex = e.target.selectedIndex;
            // const selectedOption = e.target.options[selectedIndex];
            // const virtualData = selectedOption.getAttribute('data-virtual');
            // console.log(virtualData);
            pickLatLng.current = virtualData;
            if(!vsSelectedRef.current.includes("PU")){vsSelectedRef.current.push("PU")};
            let filteredMapMarkers = mapData.filter((item)=>{
              return item.Type === "DO";
            });
            filteredMapMarkers.push(
              {lat:parseFloat(pickLatLng.current.split(",")[0]),
                lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
                name:(riderName === "" ? "N/A" : riderName.trim()), address: name
              },
            );
            setMapData(filteredMapMarkers);
            setInputSuggestionListPU("");
            if(dropLatLng.current !== "")
            {
              puVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
              //handleAddressDetails("PU", name);
            }
            setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
            // handleWalkDistanceCalculation("PU", pickLatLng.current);
          }
          else //if address entered is valid and VS changed
          {
            // handleWalkDistanceCalculation("PU", virtualData);
            setPickupAddr(name);
            pickLatLng.current = virtualData;
            if(dropLatLng.current !== "")
            {
              puVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
              //handleAddressDetails("PU", name);
            }
          } 
        }
        
      }
      else if(e.target.title.toLowerCase().includes("drop off"))
      {
        mapPointDropoffSelection.current = [];
        if(e.target.value === "DO VS")
        {
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, DOWalk:0, DODuration:0}));
          if(dropLatLng.current === ""){
            setDropAddr("");
          }
        }
        else
        {
          vsChangeRef.current.type = vsChangeRef.current.type.length === 0 ? "DO ": (vsChangeRef.current.type.includes("DO")? vsChangeRef.current.type:vsChangeRef.current.type+"DO ");
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:e.target.value, name:nm});
          if(dropLatLng.current === ""){
            setDropAddr(name);
            
            dropLatLng.current = virtualData;
            if(!vsSelectedRef.current.includes("DO")){vsSelectedRef.current.push("DO")};
            let filteredMapMarkers = mapData.filter((item)=>{
              return item.Type === "PU";
            });
            filteredMapMarkers.push(
              {lat:parseFloat(dropLatLng.current.split(",")[0]),
                lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
                name:(riderName === "" ? "N/A" : riderName.trim()), address: name
              },
            );
            setMapData(filteredMapMarkers);
            setInputSuggestionListPU("");
            if(pickLatLng.current !== "")
            {
              doVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
              //handleAddressDetails("DO", name);
            }
            setWalkDistance(prevWalkDistance=>({...prevWalkDistance, DOWalk:0, DODuration:0}));
            // handleWalkDistanceCalculation("DO", dropLatLng.current);
          }
          else
          {
            // handleWalkDistanceCalculation("DO", virtualData);
            setDropAddr(name);
            dropLatLng.current = virtualData;
            if(pickLatLng.current !== "")
            {
              doVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
              //handleAddressDetails("DO", name);
            }
          }  
        }
        
      }
    }
    catch(err){console.log(err);}
  };

  const handleWalkDistanceCalculation = async(type, vsLatLng)=>{
    try
    {
     //alert("           WalkDistance");
      if(type === "PU")
      {
        let addressAPI = ITCMapDirections + "?origin=" + pickLatLng.current + "&destination=" + vsLatLng + "&AppType=calltaker&walking=true"; //"&bounds=" + mapBounds+ 
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          'Authorization': 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password),
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'
        }, {});
        // console.log(OSRMResponse);
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let distanceInMiles = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          let duration = Math.round(parseFloat(parseInt(durationInSeconds)/60));
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:distanceInMiles, PUDuration:duration}));
          // console.log(walkDistance.PUWalk, distanceInMiles, duration);
        }
        else if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "ZERO_RESULTS")
        {
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
        }
      }
      else
      {
        let addressAPI = ITCMapDirections + "?origin=" + vsLatLng + "&destination=" + dropLatLng.current + "&AppType=calltaker&walking=true"; //"&bounds=" + mapBounds+ 
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          'Authorization': 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password),
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'
        }, {});
        // console.log(OSRMResponse);
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let distanceInMiles = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          let duration = Math.round(parseFloat(parseInt(durationInSeconds)/60));
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, DOWalk:distanceInMiles, DODuration:duration}));
          // console.log(walkDistance.DOWalk, distanceInMiles, duration);
        }
        else if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "ZERO_RESULTS")
        {
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, DOWalk:0, DODuration:0}));
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleResetAll = (type)=>{
      try {
      checkCondition();
      setIsHandleResetAll(true);
      setIsSchTimeFieldDisabled(true);
      isValidateRCZCalledFromReset.current = true;
      PersistStorage.save("rowDataCallAgent", [], 999, true);
      setSearchButtonValidation("");
      setMapData([]);
      setClientInfo("");
      setSchTime("");
      setRecentAddresses([]);
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});
      // setConfirmationNo("");
      setSchPUTime("");
      setTripStatus("");
      riderNameRef.current.style.borderColor = "";
      riderNameRef.current.style.borderWidth = "";
      phoneRef.current.style.borderColor = "";
      phoneRef.current.style.borderWidth = "";
      setClientSummary({...clientSummary, totalCalls:0, totalNS:0, 
        totalCancels:0, lastCall:"",
        tripDistance:0.0, TripDuration:0.0, TripFare:0.0
      });
      setRiderName("");
      setAgentNotes("");
      setPhone("");
      setRiderNameCheck("");
      setCallBackPhone("");
      setPassengerTypeCount({...passengerTypeCount, ambPass: 1, totalSA: 0,
        totalWC: 0, totalPass: 0, total:1
      });
      setPickupAddr("");
      setDropAddr("");
      // setPickLatLng("");
      // setDropLatLng("");
      pickLatLng.current = "";
      dropLatLng.current = "";
      setPickExtraInfo("");
      setDropExtraInfo("");
      setSubmitBtnTitle("Book");
      setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
      setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
      setZones("");
      setCOSSelected(1);
      if(type==="none"){setFSSelected(FSTargetID); setPaySelected(PayTargetID);} 
      bookBtnRef.current.disabled = true;
      //setConditionMet(false);
      setTimeout(() => {
        setConditionMet(false);
      }, 2000);
    }
    catch(err){console.log(err);}
  };

  const handlePUAddrChanged = async(e)=>{
    try{
      let input = e.target.value.toLowerCase();
      if(input == ""){
        setIsSchTimeFieldDisabled(true);
      }
      bookBtnRef.current.disabled = true;
      if(input.trim() === ""){handleClearAddr("PU");}
      setPickupAddr(input);
      setZones("");
      vsSelectedRef.current = vsSelectedRef.current.filter(item => item !== "PU");
      // setMapData([]);
      setClientSummary({...clientSummary, 
        tripDistance: 0, TripDuration:0, TripFare:0.0
      });
      // setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});
      // setPickLatLng("");
      pickLatLng.current = "";
      liRefs.current = [];
      let filteredAddresses = recentAddresses.length > 0 ? recentAddresses.filter(item => { 
        let formattedAddr = item.PUAddress + ", " + item.PUCity + ", " + item.PUState + " " + item.PUZip + ", USA";
        return input.trim().length === 0 || formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
      }) : [];
      let recentAddrHTML = filteredAddresses.length > 0 ? filteredAddresses.map(function(item, index){

        try {
          liRefRecentPickupAddressComponenet.current[index] = item;
        } catch (error) {}

        let formattedAddr = item.PUAddress+", "+item.PUCity+", "+item.PUState+" "+item.PUZip+", USA";
        let LatLng = String(item.PULat)+","+String(item.PULong);
        if(input.trim().length > 0 && formattedAddr.toLowerCase().includes(input.trim().toLowerCase()))
        {
          liRefs.current[index] = React.createRef();
          return(
            <li ref={liRefs.current[index]} recentaddressindex={index} isrecentaddress="true" className="border-bottom text-nowrap overflow-hidden addressSelectionRow" title={formattedAddr} onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();
                  // PUListRef.current.focus();
                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handlePUSuggestionClicked(e);
                }
              }}
              onClick={handlePUSuggestionClicked} key={index} value={formattedAddr} data-virtual={LatLng}
            >
              {formattedAddr}
            </li>
          );
        }
        else if(input.trim() === "")
        {
          liRefs.current[index] = React.createRef();
          try {
            let result = ParseGeoCodedData(item, "", index);
            liRefRecentPickupAddressComponenet.current[index] = result;
          } catch (error) {}
          return(
            <li ref={liRefs.current[index]} recentaddressindex={index} isrecentaddress="true" className="border-bottom text-nowrap overflow-hidden addressSelectionRow" title={formattedAddr} onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
              style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();
                  // PUListRef.current.focus();
                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex + 1) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(liRefs.current.length > 0)
                  {
                    setHighlightedIndex((prevIndex) => {
                      const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handlePUSuggestionClicked(e);
                }
              }}
              onClick={handlePUSuggestionClicked} key={index} value={formattedAddr} data-virtual={LatLng}
            >
              {formattedAddr}
            </li>
          );
        }
        
      }): "";
      if(input.trim().length > 8)
      {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", "Basic "+btoa(OSRM_Username + ":" + OSRM_Password));
        myHeaders.append('Content-Type', 'application/json');
        let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
        let addressAPI = ITCMapURL + encodeURIComponent(input) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get2", myHeaders, {});
        // console.log(OSRMResponse);
        let SuggestedAddrArray = [];
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
          {
            return item;
          });
          // setSuggestedPUAddressArr(SuggestedAddrArray);
          // backgroundColor:highlightedIndex === index? 'lighblue':''  |||||||||||| ref={liRefs.current[index]}
          // let correctSuggestions = SuggestedAddrArray.filter(item=> item.formatted_address.toLowerCase().slice(0, input.length) === input);
          liRefs.current = [];
          liRefPickupAddressComponenet.current = [];
          focusedSuggestionCheckPU.current = false;
          let suggestionsHTML = SuggestedAddrArray.length > 0? SuggestedAddrArray.map(function(item, index){
            try {
              let result = ParseGeoCodedData(item, "", index);
              liRefPickupAddressComponenet.current[index] = result;
            } catch (error) {}
         
            let LatLng = String(item.geometry.location.lat) +","+ String(item.geometry.location.lng);
            liRefs.current[index] = React.createRef(); // Create a ref for each <li>
            return(
              <li ref={liRefs.current[index]} index={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow" title={item.formatted_address} onFocus={()=>{focusedSuggestionCheckPU.current = true;}}
                style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();
                      // PUListRef.current.focus();
                      if(liRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefs.current.length;
                          liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                          liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      handlePUSuggestionClicked(e);
                    }
                }}
                onClick={handlePUSuggestionClicked} key={index} value={item.formatted_address} data-virtual={LatLng}
              >
                {item.formatted_address}
              </li>
            );
          }): "";
          // let combinedHTML = [].concat(recentAddrHTML, suggestionsHTML);
          if(suggestionsHTML !== "" && e.target.value !== "")
          {
            setInputSuggestionListPU(suggestionsHTML);
          }
          else if(recentAddrHTML.length > 0)
          {
            setInputSuggestionListPU(recentAddrHTML);
          }
        }
      }
      else if(input.trim().length === 0)
      {
        if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListPU(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListPU("");
        }
      }
      else
      {
        if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListPU(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListPU("");
        }
      }
    }
    catch(err){console.log(err);}
  };
  const handlePUSuggestionClicked = (e)=>{
    try{  
      let selectedIndex = e.target.getAttribute('index');
      let selectedIndexAddressComponent = "";
      if(selectedIndex != undefined && selectedIndex != null)
      {
        selectedIndex = parseInt(selectedIndex);
        if(selectedIndex >= 0 && liRefPickupAddressComponenet != undefined)
        {
          selectedIndexAddressComponent = liRefPickupAddressComponenet?.current[selectedIndex];
          mapPointPickupSelection.current = selectedIndexAddressComponent;
        }
      }
      else 
      {
        let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
        let selectedIndexRecentAddressComponent = "";
        if(_IsRecentAddressSelected != undefined && _IsRecentAddressSelected != null){
          let recentaddressindex = e.target.getAttribute('recentaddressindex');
          if(recentaddressindex != undefined && recentaddressindex != null){
            recentaddressindex = parseInt(recentaddressindex);
            if(recentaddressindex >=0 && liRefRecentPickupAddressComponenet != undefined){
              selectedIndexRecentAddressComponent = liRefRecentPickupAddressComponenet?.current[recentaddressindex];
              mapPointPickupSelection.current = selectedIndexRecentAddressComponent;
            }
          }
        }
      }

      // let correctDate = formatDate(selectedDateSchTime);
      setPickupAddr(e.target.textContent);
      // setPickLatLng(e.target.dataset.virtual);
      pickLatLng.current = e.target.dataset.virtual;
      let filteredMapMarkers = mapData.filter((item)=>{
        return item.Type === "DO";
      });
      filteredMapMarkers.push(
        {lat:parseFloat(pickLatLng.current.split(",")[0]),
          lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
          name:(riderName === "" ? "N/A" : riderName.trim()), address: e.target.textContent
        },
      );
      // console.log(tripLatLng);
      setMapData(filteredMapMarkers);
      setInputSuggestionListPU("");
      if(dropLatLng.current !== "")
      {
        setIsSchTimeFieldDisabled(false);
        wrapperHandleAddressDetails("PU", e.target.textContent);
        //handleAddressDetails("PU", e.target.textContent);
        wrapperHandleRCZVerification("PU", e.target.textContent);
      }
    }
    catch(er){console.log(er);}
  };

  const handleDOAddrChanged = async(e)=>{
    try{
      let input = e.target.value.toLowerCase();
      if(input == ""){
        setIsSchTimeFieldDisabled(true);
      }
      bookBtnRef.current.disabled = true;
      setDropAddr(input);
      setZones("");
      if(input.trim() === ""){handleClearAddr("DO");}
      vsSelectedRef.current = vsSelectedRef.current.filter(item => item !== "DO");
      // setMapData([]);
      setClientSummary({...clientSummary, 
        tripDistance: 0, TripDuration:0, TripFare:0.0
      });
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});
      // setDropLatLng("");
      dropLatLng.current = "";
      liRefsDO.current = [];
      let filteredAddresses = recentAddresses.length > 0 ? recentAddresses.filter(item => { 
        let formattedAddr = item.DOAddress+", "+item.DOCity+", "+item.DOState+" "+item.DOZip+", USA";
        return input.trim().length === 0 || formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
      }) : [];
      let recentAddrHTML = filteredAddresses.length > 0 ? filteredAddresses.map(function(item, index){

        try {
          liRefRecentDropoffAddressComponenet.current[index] = item;
        } catch (error) {}

        let formattedAddr = item.DOAddress+", "+item.DOCity+", "+item.DOState+" "+item.DOZip+", USA";
        let LatLng = String(item.DOLat)+","+String(item.DOLong);
        liRefsDO.current[index] = React.createRef();
        return(
          <li ref={liRefsDO.current[index]} recentaddressindex={index} isrecentaddress="true"  className="border-bottom text-nowrap overflow-hidden addressSelectionRow" title={formattedAddr} onFocus={()=>{focusedSuggestionCheckDO.current = true;}}
            style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckDO.current = false;}} onKeyDown={(e)=>{
              if(e.key === 'ArrowDown')
              {
                e.preventDefault();
                // PUListRef.current.focus();
                if(liRefsDO.current.length > 0)
                {
                  setHightlightedIndexDO((prevIndex) => {
                    const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                    liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                    return newIndex;
                  });
                }
              }
              else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if(liRefsDO.current.length > 0)
                {
                  setHightlightedIndexDO((prevIndex) => {
                    const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                    liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                    return newIndex;
                  });
                }
              }
              else if(e.key === "Enter")
              {
                handleDOSuggestionClicked(e);
              }
            }}
            onClick={handleDOSuggestionClicked} key={index} value={formattedAddr} data-virtual={LatLng}
          >
            {formattedAddr}
          </li>
        );
      }): "";
      if(input.trim().length > 8)
      {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", "Basic "+btoa(OSRM_Username + ":" + OSRM_Password));
        myHeaders.append('Content-Type', 'application/json');
        let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds=" + mapBounds+
        let addressAPI = ITCMapURL + encodeURIComponent(input) + "&bounds=" + mapBounds + "&AppType=Web_Reservation";
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get2", myHeaders, {});
        // console.log(OSRMResponse);
        let SuggestedAddrArray = [];
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
          {
            return item;
          });
          // console.log(SuggestedAddrArray);
          // let correctSuggestions = SuggestedAddrArray.filter(item=> item.formatted_address.toLowerCase().slice(0, input.length) === input);
          focusedSuggestionCheckDO.current = false;
          liRefsDO.current = [];
          let suggestionsHTML = SuggestedAddrArray.length > 0? SuggestedAddrArray.map(function(item, index){
             try {
              let result = ParseGeoCodedData(item, "", index);
              liRefDropoffAddressComponenet.current[index] = result;
            } catch (error) {}
            let LatLng = String(item.geometry.location.lat) +","+ String(item.geometry.location.lng);
            liRefsDO.current[index] = React.createRef();
            return(
              <li ref={liRefsDO.current[index]} index={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow" title={item.formatted_address} 
                style={{cursor:"pointer"}} tabIndex={-1}
                onKeyDown={(e)=>{
                  if(e.key === 'ArrowDown')
                  {
                    e.preventDefault();
                    // PUListRef.current.focus();
                    if(liRefsDO.current.length > 0)
                    {
                      setHightlightedIndexDO((prevIndex) => {
                        const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                        liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                        return newIndex;
                      });
                    }
                  }
                  else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    if(liRefsDO.current.length > 0)
                    {
                      setHightlightedIndexDO((prevIndex) => {
                        const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                        liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                        return newIndex;
                      });
                    }
                  }
                  else if(e.key === "Enter")
                  {
                    handleDOSuggestionClicked(e);
                  }
                }} onFocus={()=>{focusedSuggestionCheckDO.current = true;}} onBlur={()=>{focusedSuggestionCheckDO.current = false;}}
                onClick={handleDOSuggestionClicked} key={index} value={item.formatted_address} data-virtual={LatLng}
              >
                {item.formatted_address}
              </li>
            );
          }): "";
          if(suggestionsHTML !== "" && e.target.value !== "")
          {
            setInputSuggestionListDO(suggestionsHTML);
          }
          else if(recentAddrHTML.length > 0)
          {
            setInputSuggestionListDO(recentAddrHTML);
          }
        }
      }
      else if(input.trim().length === 0)
      {
        if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListDO(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListDO("");
        }
      }
      else
      {
        if(recentAddrHTML.length > 0)
        {
          setInputSuggestionListDO(recentAddrHTML);
        }
        else
        {
          setInputSuggestionListDO("");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleDOSuggestionClicked = (e)=>{
    try{  
      let selectedIndex = e.target.getAttribute('index');
      let selectedIndexAddressComponent = "";
      if(selectedIndex != undefined && selectedIndex != null)
      {
        selectedIndex = parseInt(selectedIndex);
        if(selectedIndex >= 0 && liRefDropoffAddressComponenet != undefined)
        {
          selectedIndexAddressComponent = liRefDropoffAddressComponenet?.current[selectedIndex];
          mapPointDropoffSelection.current = selectedIndexAddressComponent;
        }
      }
      {
        let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
        let selectedIndexRecentAddressComponent = "";
        if(_IsRecentAddressSelected != undefined && _IsRecentAddressSelected != null){
          let recentaddressindex = e.target.getAttribute('recentaddressindex');
          if(recentaddressindex != undefined && recentaddressindex != null){
            recentaddressindex = parseInt(recentaddressindex);
            if(recentaddressindex >=0 && liRefRecentDropoffAddressComponenet != undefined){
              selectedIndexRecentAddressComponent = liRefRecentDropoffAddressComponenet?.current[recentaddressindex];
              mapPointDropoffSelection.current = selectedIndexRecentAddressComponent;
            }
          }
        }
      }

      // let correctDate = formatDate(selectedDateSchTime);
      setDropAddr(e.target.textContent);
      dropLatLng.current = e.target.dataset.virtual;
      let filteredMapMarkers = mapData.filter((item)=>{
        return item.Type === "PU";
      });
      filteredMapMarkers.push(
        {lat:parseFloat(dropLatLng.current.split(",")[0]),
          lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
          name:(riderName === "" ? "N/A" : riderName.trim()), address: e.target.textContent
        },
      );
      // console.log(tripLatLng);
      setMapData(filteredMapMarkers);
      // console.log("drop latlng", e.target.dataset.virtual);
      setInputSuggestionListDO("");
      if(pickLatLng.current !== "")
      {
        setIsSchTimeFieldDisabled(false);
        wrapperHandleAddressDetails("DO", e.target.textContent);
        //handleAddressDetails("DO", e.target.textContent);
        wrapperHandleRCZVerification("DO", e.target.textContent);
      }
    }
    catch(er){console.log(er);}
  };

  const wrapperHandleRCZVerification = async(type, actualAddr, addr2 = " ") => {
    try {
      await handleRCZVerification(type, actualAddr, addr2);
    } catch (error) {
      
    }
  }

  const handleRCZVerification = async(type, actualAddr, addr2 = " ")=>{
    try{
     
      const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
      const currDate = new Date().toLocaleDateString('en-US', options);
      const currTime = new Date().toLocaleTimeString();
      let data = {};
      bookBtnRef.current.disabled = true;
      // console.log(vsSelectedRef.current);
      // console.log(dropAddr);
      let verifiedDropAddr = (dropAddr === ""? "123 Main St, Annapolis, MD 21401":dropAddr);
      let verifiedPUAddr =  (pickupAddr === ""? "123 Main St, Annapolis, MD 21401":pickupAddr);
      let pickCity = "";
      let pickState = "";
      let pickZip = "";
      let pickStreet = "";
      let dropCity = "";
      let dropState = "";
      let dropZip = "";
      let dropStreet = "";
      let combinedDataAddedTime = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value;

        // Get the current time
        const currentTime = new Date();
        let addedMinutes = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value)/60;
        // Add 10 minutes to the current time
        currentTime.setMinutes(currentTime.getMinutes() + addedMinutes);

      let userEnteredPickupAddress = null;
      try {
        userEnteredPickupAddress = prepareDataForUserEnteredPickupAddress();
      } catch (error) {
      }
      if(userEnteredPickupAddress.reqpustreet == null || userEnteredPickupAddress.reqpustreet == "")
      {
        userEnteredPickupAddress.reqpustreet = pickupAddr;
      }

      if(pickupVirtualStop?.value != undefined && pickupVirtualStop?.value != null && pickupVirtualStop?.value != ""){
        try {
          if(userEnteredPickupAddress?.reqpucity == "" || userEnteredPickupAddress?.reqpucity == undefined && userEnteredPickupAddress?.reqpucity == null)
          {
            userEnteredPickupAddress.reqpucity = VirtualStopsData.filter(p => p.ID == pickupVirtualStop.value)[0].City;
          }

          if(userEnteredPickupAddress?.reqpustate == "" || userEnteredPickupAddress?.reqpustate == undefined && userEnteredPickupAddress?.reqpustate == null)
          {
            userEnteredPickupAddress.reqpustate = VirtualStopsData.filter(p => p.ID == pickupVirtualStop.value)[0].State;
          }

          if(userEnteredPickupAddress?.reqpuzip == "" || userEnteredPickupAddress?.reqpuzip == undefined && userEnteredPickupAddress?.reqpuzip == null)
          {
            userEnteredPickupAddress.reqpuzip = VirtualStopsData.filter(p => p.ID == pickupVirtualStop.value)[0].Zipcode;
          }
          
        } catch (error) {
          
        }
      }

      let userEnteredDropoffAddress = null;
      try {
        userEnteredDropoffAddress = prepareDataForUserEnteredDropoffAddress();
      } catch (error) {
      }

      if(userEnteredDropoffAddress.reqdostreet == null || userEnteredDropoffAddress.reqdostreet == "")
      {
        userEnteredDropoffAddress.reqdostreet = dropAddr;
      }


      if(dropAddrVirtualStop?.value != undefined && dropAddrVirtualStop?.value != null && dropAddrVirtualStop?.value != ""){
        try {
          if(userEnteredDropoffAddress?.reqdocity == "" || userEnteredDropoffAddress?.reqdocity == undefined && userEnteredDropoffAddress?.reqdocity == null)
          {
            userEnteredDropoffAddress.reqdocity = VirtualStopsData.filter(p => p.ID == dropAddrVirtualStop.value)[0].City;
          }

          if(userEnteredDropoffAddress?.reqdostate == "" || userEnteredDropoffAddress?.reqdostate == undefined && userEnteredDropoffAddress?.reqdostate == null)
          {
            userEnteredDropoffAddress.reqdostate = VirtualStopsData.filter(p => p.ID == dropAddrVirtualStop.value)[0].State;
          }

          if(userEnteredDropoffAddress?.reqdozip == "" || userEnteredDropoffAddress?.reqdozip == undefined && userEnteredDropoffAddress?.reqdozip == null)
          {
            userEnteredDropoffAddress.reqdozip = VirtualStopsData.filter(p => p.ID == dropAddrVirtualStop.value)[0].Zipcode;
          }
          
        } catch (error) {
          
        }

      }

      if(vsSelectedRef.current.includes("PU"))
      {
        pickCity = "";
        pickState = "";
        pickZip = "";
        pickStreet = "";
      }
      else
      {
        if(type === "PU")
        {
          pickCity = "";
          pickState = "";
          pickZip = "";
          pickStreet = "";
        }
        else
        {
          pickCity = "";
          pickState = "";
          pickZip = "";
          pickStreet = "";
        }
      }
      if(vsSelectedRef.current.includes("DO"))
      {
        dropCity = "";
        dropState = "";
        dropZip = "";
        dropStreet = "";
      }
      else
      {
        if(type === "DO")
        {
          dropCity = "";
          dropState = "";
          dropZip = "";
          dropStreet = "";
        }
        else
        {
          dropCity = "";
          dropState = "";
          dropZip = "";
          dropStreet = "";
        }
      }
      if(type === "PU")
      {
        
        data = {
          "Ta01": (combinedDataAddedTime? combinedDataAddedTime:0),
          "iAffiliateID": parseInt(selectedAff),
          "vPULatitude": pickLatLng.current.split(",")[0],
          "vPULongitude": pickLatLng.current.split(",")[1],
          "vDOLatitude": dropLatLng.current.split(",")[0],
          "vDOLongitude": dropLatLng.current.split(",")[1],
          "dtPickupDateTime": schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00",//"01/01/1900 00:00:00",
          "dEstimatedTime": 0.0,
          "RCZList": "",
          "ErrorMessage": "",
          "PUDONearbyVS" :  {"userid": loginData.iUserID, "brandid": "3", "iAffiliateID": parseInt(selectedAff), "pulocation": "", "pustreet":  pickStreet, 
            "pucity": pickCity, "pustate": pickState, "puzip": pickZip, 
            "puaddress": actualAddr, "puinstruction": pickExtraInfo, 
            "pulatitude": pickLatLng.current.split(",")[0], "pulongitude": pickLatLng.current.split(",")[1], "dolocation": "", "dostreet": dropStreet, 
            "docity": dropCity, "dostate": dropState, "dozip": dropZip, 
            "doaddress": verifiedDropAddr, "doinstruction": dropExtraInfo, 
            "dolatitude": dropLatLng.current.split(",")[0], "dolongitude": dropLatLng.current.split(",")[1]
          },
          "vPUStreetAddress": userEnteredPickupAddress?.reqpustreet != null ? userEnteredPickupAddress.reqpustreet : "", 
          "vPUCity": userEnteredPickupAddress?.reqpucity != null ? userEnteredPickupAddress.reqpucity : "", 
          "vPUState": userEnteredPickupAddress?.reqpustate != null ? userEnteredPickupAddress.reqpustate : "", 
          "vPUZip": userEnteredPickupAddress?.reqpuzip != null ? userEnteredPickupAddress.reqpuzip : "", 
          "vDOStreetAddress": userEnteredDropoffAddress?.reqdostreet != null ? userEnteredDropoffAddress.reqdostreet : "", 
          "vDOCity": userEnteredDropoffAddress?.reqdocity != null ? userEnteredDropoffAddress.reqdocity : "", 
          "vDOState": userEnteredDropoffAddress?.reqdostate != null ? userEnteredDropoffAddress.reqdostate : "",
          "vDOZip": userEnteredDropoffAddress?.reqdozip != null ? userEnteredDropoffAddress.reqdozip : "", 
          "iAppID": iAppID, 
          "iUserID": String(loginData.iUserID),
          "vPUStopName": pickupVirtualStop.name != "" ? pickupVirtualStop.name : puVSValueChanged.current,
          "vDOStopName": dropAddrVirtualStop.name != "" ? dropAddrVirtualStop.name : doVSValueChanged.current,
          "vCustomerPhone": phone,
          "vCustomerName": riderName
        };
      }
      else if(type === "DO")
      {
        data = {
          "Ta01": (combinedDataAddedTime? combinedDataAddedTime:0),
          "iAffiliateID": parseInt(selectedAff),
          "vPULatitude": pickLatLng.current.split(",")[0],
          "vPULongitude": pickLatLng.current.split(",")[1],
          "vDOLatitude": dropLatLng.current.split(",")[0],
          "vDOLongitude": dropLatLng.current.split(",")[1],
          "dtPickupDateTime": schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00",//"01/01/1900 00:00:00",
          "dEstimatedTime": 0.0,
          "RCZList": "",
          "ErrorMessage": "",
          "PUDONearbyVS" :  {"userid": loginData.iUserID, "brandid": "3", "iAffiliateID": parseInt(selectedAff), "pulocation": "", "pustreet":  pickStreet, 
            "pucity": pickCity, "pustate": pickState, "puzip": pickZip, 
            "puaddress": verifiedPUAddr, "puinstruction": pickExtraInfo, 
            "pulatitude": pickLatLng.current.split(",")[0], "pulongitude": pickLatLng.current.split(",")[1], "dolocation": "", "dostreet": dropStreet, 
            "docity": dropCity, "dostate": dropState, "dozip": dropZip, 
            "doaddress": actualAddr, "doinstruction": dropExtraInfo, 
            "dolatitude": dropLatLng.current.split(",")[0], "dolongitude": dropLatLng.current.split(",")[1]
          },
          "vPUStreetAddress": userEnteredPickupAddress?.reqpustreet != null ? userEnteredPickupAddress.reqpustreet : "", 
          "vPUCity": userEnteredPickupAddress?.reqpucity != null ? userEnteredPickupAddress.reqpucity : "", 
          "vPUState": userEnteredPickupAddress?.reqpustate != null ? userEnteredPickupAddress.reqpustate : "", 
          "vPUZip": userEnteredPickupAddress?.reqpuzip != null ? userEnteredPickupAddress.reqpuzip : "", 
          "vDOStreetAddress": userEnteredDropoffAddress?.reqdostreet != null ? userEnteredDropoffAddress.reqdostreet : "", 
          "vDOCity": userEnteredDropoffAddress?.reqdocity != null ? userEnteredDropoffAddress.reqdocity : "", 
          "vDOState": userEnteredDropoffAddress?.reqdostate != null ? userEnteredDropoffAddress.reqdostate : "",
          "vDOZip": userEnteredDropoffAddress?.reqdozip != null ? userEnteredDropoffAddress.reqdozip : "", 
          "iAppID": iAppID,
          "iUserID": String(loginData.iUserID),
          "vPUStopName": pickupVirtualStop.name != "" ? pickupVirtualStop.name : puVSValueChanged.current,
          "vDOStopName": dropAddrVirtualStop.name != "" ? dropAddrVirtualStop.name : doVSValueChanged.current,
          "vCustomerPhone": phone,
          "vCustomerName": riderName
        };
      }
      setModalHeaderText("Validation");
      setModalBodyHTML("Please wait for the validation...");
      setModalFooterHTML("");
      setModalClass("d-none");
      setShowDynamicModal(true);
      xCancelSourceForGrid.current = APICom.GenerateSource();
      setShowAPILoader(true);
      let response = await APICom.fetchData("ReservationCoreURL","ValidateRCZ", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );
      if(response.error.length === 0)
      {
        console.log(response);
        let errorMsg  = response.data.errorMessage;
        let responseMsg = response.data.responseMessage;
        if(responseMsg && responseMsg !== "")
        {
          setModalHeaderText("RCZ Verification Error");
          setModalBodyHTML(responseMsg);
          setModalFooterHTML(
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setZones("");
          setShowAPILoader(false);
        }
        else if(errorMsg && errorMsg !== "")
        {
          setModalHeaderText("RCZ Verification Error");
          setModalBodyHTML(errorMsg);
          setModalFooterHTML(
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setZones("");
          setShowAPILoader(false);
        }
        else
        {
          //Work after verification
          if(pickLatLng.current === dropLatLng.current)
          {
            setShowAPILoader(false);
            setModalHeaderText("Identical Address Selection Error");
            setModalBodyHTML("Please select two different addresses to continue.");
            setModalFooterHTML(
              <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setModalClass("");
            setShowDynamicModal(true);
          }
          else
          {
            if(response.data.pudoNearbyVS.pvs && response.data.pudoNearbyVS.dvs)
            {
              setModalClass("");
              setShowDynamicModal(false);
              setShowAPILoader(false);
              setRczVerifData(response.data);
              bookBtnRef.current.disabled = false;
              if(response.data.rczList)
              {
                setZones(response.data.rczList);
              }

              if(response.data.errorMessageForServiceHour != "" && response.data.errorMessageForServiceHour != null){
                setModalHeaderText("Service hours validation");
                setModalBodyHTML(response.data.errorMessageForServiceHour);
                setModalFooterHTML(
                  <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setModalClass("");
                setShowDynamicModal(true);
              }
              
              let tripLatLng = []; //starts with given address, second is PU VS, third is DO VS, and final is the given destination
              
              tripLatLng.push(
                (response.data.pudoNearbyVS.pvs.latitude !== response.data.pudoNearbyVS.pu.latitude && response.data.pudoNearbyVS.pvs.longitude !== response.data.pudoNearbyVS.pu.longitude
                ? {lat:parseFloat((pickLatLng.current.split(",")[0])),
                  lng: parseFloat((pickLatLng.current.split(",")[1])), Type:"Walk", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(type === "PU"? actualAddr:(pickupAddr === ""? addr2:pickupAddr))
                }:{lat:"",
                lng: "", Type:"Walk", 
                name:(riderName === "" ? "N/A" : riderName.trim()), 
                address:(type === "PU"? actualAddr:(pickupAddr === ""? addr2:pickupAddr))
                }),
                {lat: (parseFloat(response.data.pudoNearbyVS.pvs.latitude)),
                  lng: (parseFloat(response.data.pudoNearbyVS.pvs.longitude)), Type:"PU", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(response.data.pudoNearbyVS.pvs.address)
                },
                {lat:(parseFloat(response.data.pudoNearbyVS.dvs.latitude)),
                  lng: (parseFloat(response.data.pudoNearbyVS.dvs.longitude)), Type:"DO", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(response.data.pudoNearbyVS.dvs.address)
                },
                (response.data.pudoNearbyVS.dvs.latitude !== response.data.pudoNearbyVS.do.latitude && response.data.pudoNearbyVS.dvs.longitude !== response.data.pudoNearbyVS.do.longitude
                ? {lat:parseFloat((dropLatLng.current.split(",")[0])),
                  lng: parseFloat((dropLatLng.current.split(",")[1])), Type:"Drop", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(type === "DO"? actualAddr:(dropAddr === ""?addr2:dropAddr))
                }:{lat:"",
                lng: "", Type:"Drop", 
                name:(riderName === "" ? "N/A" : riderName.trim()), 
                address:(type === "DO"? actualAddr:(dropAddr === ""?addr2:dropAddr))
                }),
              );
              
              console.log(tripLatLng, pickLatLng.current, dropLatLng.current);
              //setMapData(tripLatLng); // commented for c
              let matchedDataPUVS = "";
              let matchedDataDOVS = "";
              for(let k = 0; k < VirtualStopsData.length; k++)
              {
                if(parseInt(selectedAff) === parseInt(VirtualStopsData[k].iSATSPID))
                {
                  if(response.data.pudoNearbyVS.pvs && String(response.data.pudoNearbyVS.pvs.id) === String(VirtualStopsData[k].ID))
                  {
                    matchedDataPUVS = VirtualStopsData[k].Location+"$"+VirtualStopsData[k].ID;
                  }
                  if(response.data.pudoNearbyVS.dvs && String(response.data.pudoNearbyVS.dvs.id) === String(VirtualStopsData[k].ID))
                  {
                    matchedDataDOVS = VirtualStopsData[k].Location+"$"+VirtualStopsData[k].ID;
                  }
                }
              }
              // console.log(selectedAff, vsChangeRef.current);
              if(response.data.pudoNearbyVS.pvs) {
                setPickupVirtualStop((matchedDataPUVS === "" ? {...pickupVirtualStop, value:"PU VS", name:""}
                :{...pickupVirtualStop, value:matchedDataPUVS.split("$")[1], name:matchedDataPUVS.split("$")[0]})); 
                let pickLatLng = response.data.pudoNearbyVS.pvs.latitude+","+response.data.pudoNearbyVS.pvs.longitude;
                await handleWalkDistanceCalculation("PU", pickLatLng);
              }
              
              if(response.data.pudoNearbyVS.dvs) {
                setDropAddrVirtualStop((matchedDataDOVS === "" ? {...dropAddrVirtualStop, value:"DO VS", name:""}
                :{...dropAddrVirtualStop, value:matchedDataDOVS.split("$")[1], name:matchedDataDOVS.split("$")[0]}));
                let dropLatLng = response.data.pudoNearbyVS.dvs.latitude+","+response.data.pudoNearbyVS.dvs.longitude;
                await handleWalkDistanceCalculation("DO", dropLatLng);
              }
              // if(!vsChangeRef.current.type.includes("PU"))
              // {
                
              //   // setWalkDistance({...walkDistance, PUWalk:0});
                
              // }
              // if(!vsChangeRef.current.type.includes("DO"))
              // {
                
              // }
              vsChangeRef.current.type = "";
              setMapData(tripLatLng);
            }
            else if (response.data.pudoNearbyVS.responseCode != 200 && response.data.pudoNearbyVS.responseMessage != "")
            {
              setModalHeaderText("Validation");
              setModalBodyHTML(response.data.pudoNearbyVS.responseMessage);
              setModalFooterHTML(
                <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setZones("");
              setShowAPILoader(false);
            }
            else
            {
              setModalHeaderText("No Virtual Stop Assigned");
              setModalBodyHTML("The verification process could not provide virtual stops for the given addresses. Please try again.");
              setModalFooterHTML(
                <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setZones("");
              setShowAPILoader(false);
            }
          }
          
          
        }
      }
      else
      {
        setModalHeaderText("RCZ Verification Failed");
        setModalBodyHTML(response.error);
        setModalFooterHTML(
          <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setModalClass("");
        setShowDynamicModal(true);
        setShowAPILoader(false);
      }
    }
    catch(err){console.log(err);}
  }


  const wrapperHandleAddressDetails = async(type, data)=>{
    try {
      await handleAddressDetails(type, data);
    } catch (error) {
      
    }
  }
  const handleAddressDetails = async(type, data)=>{
    try{
      if(type === "PU")
      {
        let addressAPI = ITCMapDirections + "?origin=" + pickLatLng.current + "&destination=" + dropLatLng.current + "&AppType=calltaker"; //"&bounds=" + mapBounds+ 
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          'Authorization': 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password),
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'
        }, {});
        // console.log(OSRMResponse);
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let distance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          let duration = Math.round(parseFloat(parseInt(durationInSeconds)/60));
          setClientSummary({...clientSummary, 
            tripDistance: distance, TripDuration:duration, TripFare:0.0
          });
        }
      }
      else
      {
        let addressAPI = ITCMapDirections + "?origin=" + pickLatLng.current + "&destination=" + dropLatLng.current + "&AppType=calltaker"; //"&bounds=" + mapBounds+ 
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          'Authorization': 'Basic '+btoa(OSRM_Username + ":" + OSRM_Password),
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'
        }, {});
        console.log(OSRMResponse);
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let distance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          let duration = Math.round(parseFloat(parseInt(durationInSeconds)/60));
          setClientSummary({...clientSummary, 
            tripDistance: distance, TripDuration:duration, TripFare:0.0
          });
        }
      }
      
    }
    catch(err){console.log(err);}
  };

  const handleAffChange = (e)=>{
    try{
      transitTypeRef.current = AffiliateData.filter((item,index) => {
        try{
          return parseInt(item.AffiliateID) === parseInt(e.target.value);
        }
        catch(err){console.log(err);}
      });
      setSelectedAff(e.target.value);
      let fsSelection = FundingSourceData[parseInt(e.target.value)] && FundingSourceData[parseInt(e.target.value)] !== undefined ? JSON.parse(FundingSourceData[parseInt(e.target.value)]) : [];
      let cosSelection = ClassOfServiceData[parseInt(e.target.value)] && ClassOfServiceData[parseInt(e.target.value)] !== undefined ? JSON.parse(ClassOfServiceData[parseInt(e.target.value)]) : [];
      let paySelection = PaymentTypesData[parseInt(e.target.value)] && PaymentTypesData[parseInt(e.target.value)] !== undefined ? JSON.parse(PaymentTypesData[parseInt(e.target.value)]) : [];
      let fsOptionsHTML = null;
      let cosOptionsHTML = cosSelection.map((item, index)=>{
        return(
          <option key={index} value={item.iClassOfServiceID}>
            {item.vClassName}
          </option>
        );
      });
      setCOSDropdown(cosOptionsHTML);
      let payOptionsHTML = paySelection.map((item, index)=>{
        if(index === 0)
        {
          setPayTargetID(item.iAPID);
          setPaySelected(item.iAPID);
        }
        if(item.vName !== "" && item.vName !== "-" && !item.vName.toLowerCase().includes("unused"))
        {
          return(
            <option key={index} value={item.iAPID}>
              {item.vName}
            </option>
          );
        }
      });
      setPayDropdown(payOptionsHTML);
      fsOptionsHTML = fsSelection.map((item, index)=>{
        if(item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash"))
        {
          setFSSelected(item.ID);
          setFSTargetID(item.ID);
        }
        return(
          <option key={index} value={item.ID}>
            {item.AccountID}
          </option>
        );
      });
      setFSDropdown(fsOptionsHTML);
      // console.log(fsSelection);
      setMapOptionsCallAgent(prevState=>({...prevState, mapOptions: {...prevState.mapOptions, aff:(e.target.value)}}));
      handleResetAll("func");
      let selectedAffVS = [];
      for(let k = 0; k < VirtualStopsData.length; k++)
      {
        if(parseInt(e.target.value) === parseInt(VirtualStopsData[k].iSATSPID))
        {
          selectedAffVS.push(VirtualStopsData[k]);
        }
      }
      startAffSelectionDropDown(selectedAffVS);
    }
    catch(err){console.log(err);}
  };

  const handleAutoBookTrip = ()=>{
    try{
      setRiderName("Kamran A");
      setPhone("+16667778888");
      setPickupAddr("816 Bestgate Road, Annapolis, MD 21401, USA");
      setDropAddr("2002 Annapolis Mall Road, Annapolis, MD 21401, USA");
      pickLatLng.current = "38.994088959031814,-76.53922746079853";
      dropLatLng.current = "38.98793225777333,-76.54685231846949";
      if(pickLatLng.current !== "")
      {
        handleAddressDetails("PU", "816 Bestgate Road, Annapolis, MD 21401, USA");
        wrapperHandleRCZVerification("PU", "816 Bestgate Road, Annapolis, MD 21401, USA");
      }
    }
    catch(err){console.log(err);}
  };

  const handleSetRiderName = (e)=>{
    try{
      setSearchButtonValidation("");
      const regex = /^[a-zA-Z ,.'-]+$/;
      let initialName = e.target.value;
      if(initialName.length > 0 && !regex.test(e.target.value)){e.target.value = initialName.slice(0,-1);}
      if(initialName !== "" && e.target.value.length < 4)
      {
        riderNameRef.current.style.borderColor = "red";
        riderNameRef.current.style.borderWidth = "3px";
      }
      else
      {
        riderNameRef.current.style.borderColor = "";
        riderNameRef.current.style.borderWidth = "";
      }
    }
    catch(err){console.log(err);}
  };

  const handleClearAddr = (type)=>{
    try{
      // setZones("");
      // console.log(mapData);
      if(type === "PU")
      {
        // setInputSuggestionListPU("");
        // setPickupAddr("");
        // pickLatLng.current = "";
        let filteredMapMarkers = mapData.filter((item)=>{
          return item.Type === "DO";
        });
        setMapData(filteredMapMarkers);
      }
      else
      {
        // setInputSuggestionListDO("");
        // setDropAddr("");
        // dropLatLng.current = "";
        let filteredMapMarkers = mapData.filter((item)=>{
          return item.Type === "PU";
        });
        setMapData(filteredMapMarkers);
      }
    }
    catch(err){console.log(err);}
  };

  const handlePhoneCheck = (e)=>{
    try{
      setSearchButtonValidation("");
      if(!phone)
      {
        setRecentAddresses([]);
        setRiderName("");
        setCallBackPhone("");
        // setRiderNameCheck("");
      }
      if(phone && phone.length < 12)
      {
        phoneRef.current.style.borderColor = "red";
        phoneRef.current.style.borderWidth = "3px";
        setRecentAddresses([]);
      }
      else
      {
        phoneRef.current.style.borderColor = "";
        phoneRef.current.style.borderWidth = "";
      }
    }
    catch(err){console.log(err);}
  };
  const handleClientNameCheck = ()=>{
    try{
      
      // setSearchButtonValidation("");

      if(riderNameCheck.length === 0)
      {
        setRecentAddresses([]);
        setRiderName("");
        setCallBackPhone("");
        // setPhone("");
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientInfoDisplay = ()=>{
    try{
      if(clientInfoDisplay)
      {
        setClientInfoDisplay(false);
      }
      else
      {
        setClientInfoDisplay(true);
      }
    }
    catch(err){console.log(err);}
  };

  const ResetMapFromCallTaker = () => {
   
};
  // const handlePUSuggestionScroll = (e) =>{
  //   try{
  //     if(focusedIndex === -1)
  //     {
  //       setFocusedIndex(0);
  //       console.log(PUListRef.current);
        
  //     }
  //     else
  //     {
  //       switch (e.key) {
  //         case 'ArrowDown':
  //           setFocusedIndex((prevIndex) => (prevIndex < suggestedPUAddressArr.length - 1 ? prevIndex + 1 : prevIndex));
  //           break;
  //         case 'ArrowUp':
  //           setFocusedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  //           break;
  //         default:
  //           break;
  //       }
  //     }
      
  //   }
  //   catch(err){console.log(err);}
  // };
  // useEffect(() => {
  //   if(focusedIndex === 0)
  //   {
  //     PUListRef.current.scrollTop = 0;
  //   }
  //   else
  //   {
  //     if (focusedIndex !== -1 && itemRefs.current[focusedIndex]) {
  //       console.log(itemRefs.current[focusedIndex]);
  //       itemRefs.current[focusedIndex].focus();
  //     }
  //   }
    
  // }, [focusedIndex]);

  return(
    <>
      <ARBResponseListener handlePageProgressBar={handlePageProgressBar} />
      <Row className="m-0 p-1" style={{backgroundColor:"#07447b"}}>
        <Col className="d-flex align-items-center">
          <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none p-0 m-0' style={{maxWidth:"200px", maxHeight:"30px"}} alt="ITCurves" />
          <p className="fw-bold text-white text-center text-nowrap overflow-hidden h3 user-select-none flex-grow-1" style={{margin:"0",marginLeft:"10%"}}>
            {"Microtransit Reservation"}
          </p>

          <span className="d-inline-flex text-end" style={{marginRight:"9%"}}>
              <Icon icon="bx:sitemap" className="text-white" style={{width:"20px", height:"20px"}}/>
              <label className='m-0 mx-1 user-select-none text-white'>Affiliate:</label>
              <select style={{minWidth:"110px", maxWidth:"200px", textOverflow:"ellipsis"}} value={(selectedAff? selectedAff:"")} 
                onChange={handleAffChange} className='text-center mx-1   overflow-hidden' tabIndex={-1}
              >
                {affiliateDropDownHTML}
              </select>
            </span>
        </Col>
        
        <Row className='m-0 text-end'>
          <Col className="">
            {/* <span className="d-inline-flex text-end">
              <Icon icon="bx:sitemap" className="text-white" style={{width:"20px", height:"20px"}}/>
              <label className='m-0 mx-1 user-select-none text-white'>Affiliate:</label>
              <select style={{minWidth:"110px", maxWidth:"200px", textOverflow:"ellipsis"}} value={(selectedAff? selectedAff:"")} 
                onChange={handleAffChange} className='text-center mx-1   overflow-hidden'
              >
                {affiliateDropDownHTML}
              </select>
            </span> */}
          </Col>
        </Row>
      </Row>
      <Row className='' style={{marginLeft: "10%", marginRight:"10%", boxShadow:"0px 3px 6px #999"}}>
        <Col xs={6} className="my-1 overflow-auto callAgentSummaryScroller">
          <span className="d-inline-flex" style={{width:"100%"}}>
            {/* <Icon icon="bx:phone" className="m-1" style={{width:"20px", height:"20px"}}/>
            <label className='m-0 m-1 user-select-none fw-bold'>Phone</label> */}
            <PhoneInput phoneinputattr="1" className='text-nowrap text-center mx-1 text-center w-75' style={{minWidth:"120px", maxWidth:"150px"}} ref={phoneRef}
              defaultCountry="US" autoComplete="new_pass" value={phone} onKeyUp={handlePhoneCheck} onChange={setPhone} placeholder="(XXX) XXX-XXXX"
              onClick={(e) => { if (isFirefox) { phoneRef.current.blur(); phoneRef.current.focus(); } }}
              onKeyDown={(e)=>
              {
                if(phone && phone.length >= 12 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                {
                  e.preventDefault();
                }
                if(e.key === "Enter" || e.key === "Tab")
                {
                  // if((!phone || phone.length < 12) && riderNameCheck.length > 0)
                  // {
                  //   handleSearchCustomerName();
                  // }
                  // else
                  // {
                  handleSearchCustomerPhone();
                  // }
                }
              }}
            />
            <span className="d-inline-flex mx-1">
              {/* <Icon icon="bx:user" className="m-1" style={{width:"20px", height:"20px"}}/>
              <label className='m-0 m-1 user-select-none fw-bold'>Name</label> */}
               <input type={"text"} value={riderNameCheck} onChange={handleClientNameChange} ref={clientNameCheckRef}
                onClick={(e) => { if (isFirefox) { clientNameCheckRef?.current.blur(); clientNameCheckRef?.current.focus(); } }}
                placeholder={"Client Name"} style={{minWidth:"120px", maxWidth:"150px"}} onKeyUp={handleClientNameCheck} 
                onFocus={handleClientNameChange} 
                onBlur={()=>{setTimeout(() => {
                  if(!focusedSuggestionCheckClientName.current)
                  {
                    setInputSuggestionListClientName("");
                  }
                 // clientNameCheckRef?.current.focus();
                }, 300);}}
                onKeyDown={(e)=>
                {
                  if(e.key === "Enter" || (e.key === "Tab" && !e.shiftKey))
                  {
                    
                    setInputSuggestionListClientName("");
                    if(riderNameCheck.length === 0 && phone && phone.length === 12)
                    {
                      handleSearchCustomerPhone();
                    }
                    else
                    {
                      handleSearchCustomerName();
                    }   
                  }
                  else if(e.key === 'ArrowDown')
                  {
                    e.preventDefault();
                    setHighlightedIndex(-1);
                    if(liClientNameRefs.current.length > 0)
                    {
                      if(liClientNameRefs.current[0]?.current) //check for empty references
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liClientNameRefs.current.length;
                          liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                  }
                  else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    setHighlightedIndex(-1);
                    if(liClientNameRefs.current.length > 0)
                    {
                      if(liClientNameRefs.current[0]?.current)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liClientNameRefs.current.length) % liClientNameRefs.current.length;
                          liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                  }
                }}
              />
              {inputSuggestionListClientName && inputSuggestionListClientName !== "" ?
                <ul  className="user-select-none border position-absolute px-1 bg-white" 
                  style={{width:"auto", height:"80px", overflowY:"auto", zIndex:1000, marginTop:"2.2rem"}} 
                >
                  {inputSuggestionListClientName}
                </ul>
              : ""}
            </span>
            <Button type="button" variant="success" onClick={(e)=>{if(riderNameCheck.length > 0){handleSearchCustomerName(e);}else{handleSearchCustomerPhone(e);}}} 
              title={"Client Search"} style={{fontWeight:"bold", borderRadius: "0px"}}
              className='rounded border-0' ref={searchClientBtnRef}> 
              {"Search"}
            </Button>
            {searchButtonValidation !== "" ? <p className="text-danger fw-bold small m-0 overflow-hidden user-select-none text-nowrap my-auto" 
              title={searchButtonValidation} style={{textOverflow:"ellipsis", paddingLeft:"5px"}}
            >{searchButtonValidation}</p> :""}        
          </span>
          {/* <span><label style={{color:"red", fontWeight:"bold", paddingLeft:"10px"}}>{searchButtonValidation}</label></span> */}
          {microtransit ? "":
          <>
            <span className="d-inline-flex">
              <Icon icon="bx:user" className="m-1" style={{width:"20px", height:"20px"}}/>
              <label className='m-0 m-1 user-select-none fw-bold'>Name</label>
              <input type={"text"} value={riderNameCheck} onChange={(e)=>setRiderNameCheck(e.target.value)} placeholder={"Client Name"} style={{width:"120px"}}/>
            </span>
            
          </>
          }
          
        </Col>
        <Col xs={6} className="text-end">
          <div className="d-flex justify-content-end">
            <div className="d-flex flex-nowrap overflow-auto callAgentSummaryScroller">
              <span className="d-inline-flex mt-1">
                <Icon icon="bx:comment-error" className="m-1" style={{width:"20px", height:"20px"}}/>
                <label className='m-0 my-1 user-select-none fw-bold text-nowrap' title={"Client Status"}>Client Status</label>
                <select style={{minWidth:"110px"}} tabIndex={-1} value={clientStatus} onChange={(e)=>setClientStatus(e.target.value)} disabled className='text-center mx-1'>
                  <option>Select...</option>
                </select>
              </span>
              <span className="d-inline-flex mx-1 mt-1">
                <Icon icon="bx:bus" className="m-1" style={{width:"20px", height:"20px"}}/>
                <label className='m-0 my-1 user-select-none fw-bold' title={"Class of Service (Vehicle Type)"}>COS</label>
                <select style={{minWidth:"110px"}} tabIndex={-1} value={COSSelected} onChange={(e)=>setCOSSelected(e.target.value)} className='text-center mx-1'>
                  {COSDropdown && COSDropdown.length > 0 ? COSDropdown:""}
                </select>
              </span>
            </div>
            
          </div>
        </Col>
      </Row>
      {ShowAPILoader ? <div className="loader"></div> : ""}
      <Row style={{marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999"}}>
        <Col xs={6} className="text-start" style={{backgroundColor:"#07447b"}}>
          <span className="d-inline-flex">
            <Icon icon="bx:info-circle" className="mt-1 text-white" style={{width:"25px", height:"25px"}}/>
            <label className='m-0 m-1 user-select-none fw-bold text-white'>Client Information</label>
          </span>
          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?  <span className="d-inline-flex mt-1 float-end" onClick={handleClientInfoDisplay} onKeyDown={(e)=>{if(e.key === "Enter"){handleClientInfoDisplay(e);}}}>
            {clientInfoDisplay? <Icon icon="bx:chevron-down" tabIndex={0} className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
              <Icon icon="bx:chevron-up" tabIndex={0} className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
            }
          </span>:""}
        </Col>
        <Col xs={6} className="text-center" style={{backgroundColor:"#51677c"}}>
          <span className="d-inline-flex">
            <Icon icon="bx:list-check" className="mt-1 text-white" style={{width:"25px", height:"25px"}}/>
            <label className='m-0 m-1 user-select-none fw-bold text-white'>Summary</label>
          </span>
        </Col>
      </Row>
      
      <Row className="" style={{marginLeft: "10%", marginRight:"10%", boxShadow:"0px 3px 6px #999"}}>
        <Col xs={6} tabIndex={-1} className={`${clientInfoDisplay? '':'d-none'} text-start p-0 overflow-auto callAgentSummaryScroller`} style={{maxHeight:"361px"}}>
          <Row className="m-0 w-100">
            <Row>
              <Col xs={2}>
                <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Full Name"}>
                  <Icon icon="bx:user" className="m-1" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 my-1 user-select-none'>Name</label>
                </span>
                {/* <span className="d-block small my-2 text-nowrap">
                  <Icon icon="bx:hash" className="m-1" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 my-1 user-select-none' title={"Last Confirmation Number"}>Conf</label>
                </span> */}
                <span className="d-block small mt-1 text-nowrap" title={"Pickup or Virtual Stop"}>
                  <Icon icon="bx:map" className="m-1 text-success" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 my-1 user-select-none'>PU/VS</label>
                </span>
                <span className="d-block small  text-nowrap" title={"Pickup Route Coverage Zone"}>
                  <Icon icon="bx:map-alt" className="m-1 text-info" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 my-1 user-select-none'>Zone</label>
                </span>
              </Col>
              <Col xs={10} className="p-0">
                
                <Row className="my-1">
                  <Col xs={12}>
                    <input type={"text"} value={riderName} autoComplete="new_pass" ref={riderNameRef} minLength={4} maxLength={35} required 
                      onChange={(e)=>setRiderName(e.target.value)} 
                      className='text-nowrap p-0 px-1' placeholder="Full Name" onKeyUp={handleSetRiderName} style={{width:"100%"}}
                    /> 
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col className="col-6">
                    <input type={"search"} autoComplete="new_pass" value={pickupAddr} placeholder="Pickup Address..." title={pickupAddr} onChange={handlePUAddrChanged} 
                      style={{ textOverflow:"ellipsis"}} className='text-nowrap px-1 p-0 w-100' onFocus={handlePUAddrChanged} onBlur={()=>{setTimeout(() => {
                        if(!focusedSuggestionCheckPU.current)
                        {
                          setInputSuggestionListPU("");
                        }
                      }, 300);}}
                      onKeyDown={(e)=>{
                        if(e.key === 'ArrowDown')
                        {
                          e.preventDefault();
                          setHighlightedIndex(-1);
                          if(liRefs.current.length > 0)
                          {
                            if(liRefs.current[0]?.current) //check for empty references
                            {
                              setHighlightedIndex((prevIndex) => {
                                const newIndex = (prevIndex + 1) % liRefs.current.length;
                                liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                return newIndex;
                              });
                            }
                          }
                        }
                        else if (e.key === 'ArrowUp') {
                          e.preventDefault();
                          setHighlightedIndex(-1);
                          if(liRefs.current.length > 0)
                          {
                            if(liRefs.current[0]?.current)
                            {
                              setHighlightedIndex((prevIndex) => {
                                const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                                liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                return newIndex;
                              });
                            }
                          }
                        }
                      }}
                    />
                    {/* onKeyDown={handlePUSuggestionScroll} */}
                    {inputSuggestionListPU && inputSuggestionListPU !== "" ?
                      <ul tabIndex={0} className="user-select-none border position-absolute px-1 bg-white" 
                        style={{width:"auto", maxWidth:"350px", height:"80px", overflowY:"auto", zIndex:1000}} 
                      >
                        {inputSuggestionListPU}
                      </ul>
                    :""}
                    
                  </Col>
                  <Col className="d-flex my-auto col-6">
                    <select className='text-left w-100 overflow-hidden' value={pickupVirtualStop.value} name={pickupVirtualStop.name} onChange={handleVSChange} 
                      title={"Pickup Virtual Stop: "+pickupVirtualStop.name} style={{maxHeight:"25px", textOverflow:"ellipsis"}} disabled={isVSSelectionDisabled}
                    >
                      <option value={"PU VS"}>Select Virtual Stop</option>
                      {virtualStopDropDownHTML}
                    </select>
                    {walkDistance.PUWalk !== 0?<p className="m-0 d-inline-flex user-select-none text-nowrap">{"("+walkDistance.PUWalk+"mi, "+walkDistance.PUDuration+"min)"}</p>: ""}
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col>
                    <p type={"text"} style={{textOverflow:"ellipsis"}} title={zones!==""?zones:"Unknown Zone"} className="overflow-hidden user-select-none text-nowrap m-0 w-100 fw-bold small">
                      {zones !== ""? zones:""}
                    </p>
                    
                  </Col>
                  <Col className="d-inline-flex justify-content-start">
                    <p className='m-0 mx-1 user-select-none small'>Notes</p>
                    <textarea      
                      name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                      rows={2}
                      cols={20}
                      placeholder="Pickup extra info..."
                      id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                      style={{resize:"none"}} autoComplete="new_pass"
                      value={pickExtraInfo} onChange={(e)=>setPickExtraInfo(e.target.value)}
                      className="tripDetails-label-dataFields d-inline-flex w-100 "
                    />
                  </Col>
                  
                </Row>
              </Col>
            </Row>
            <Row className="">
              <Col xs={2}>
                <span className="d-block small mt-2 text-nowrap" title={"Drop Off or Virtual Stop"}>
                  <Icon icon="bx:map" className="m-1 text-danger" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 user-select-none'>DO/VS</label>
                </span>
                <span className="d-block small mt-1 text-nowrap" title={"Drop Off Route Coverage Zone"}>
                  <Icon icon="bx:map-alt" className="m-1 text-info" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 my-1 user-select-none'>Zone</label>
                </span>
              </Col>
              <Col xs={10} className="p-0">
                <Row className="my-1">
                  <Col className="col-6">
                    <input type={"search"} placeholder="Drop Off Address..." value={dropAddr} title={dropAddr} style={{textOverflow:"ellipsis"}} 
                      onChange={handleDOAddrChanged} autoComplete="new_pass" className='text-nowrap px-1 w-100' onFocus={handleDOAddrChanged} onBlur={()=>{setTimeout(() => {
                        if(!focusedSuggestionCheckDO.current)
                        {
                          setInputSuggestionListDO("");
                        }
                      }, 300);}} 
                      onKeyDown={(e)=>{
                        if(e.key === 'ArrowDown')
                        {
                          e.preventDefault();
                          console.log(liRefsDO.current);
                          setHightlightedIndexDO(-1);
                          if(liRefsDO.current.length > 0)
                          {
                            if(liRefsDO.current[0]?.current) //check for empty references
                            {
                              setHightlightedIndexDO((prevIndex) => {
                                const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                                liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                return newIndex;
                              });
                            }
                          }
                        }
                        else if (e.key === 'ArrowUp') {
                          e.preventDefault();
                          setHightlightedIndexDO(-1);
                          if(liRefsDO.current.length > 0)
                          {
                            if(liRefsDO.current[0]?.current)
                            {
                              setHightlightedIndexDO((prevIndex) => {
                                const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                                liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                return newIndex;
                              });
                            }
                          }
                        }
                      }}
                    />
                    {inputSuggestionListDO && inputSuggestionListDO !== "" ?
                      <ul tabIndex={0} className="user-select-none border position-absolute px-1 bg-white" 
                        style={{width:"auto", maxWidth:"350px", height:"80px", overflowY:"auto", zIndex:1000}} 
                      >
                        {inputSuggestionListDO}
                      </ul>
                    :""}
                  </Col>
                  <Col className="d-flex my-auto col-6">
                    <select className='text-left w-100 overflow-hidden' value={dropAddrVirtualStop.value} name={dropAddrVirtualStop.name} disabled={isVSSelectionDisabled}
                      onChange={handleVSChange} title={"Drop Off Virtual Stop: "+dropAddrVirtualStop.name} style={{minWidth:"58px", maxHeight:"25px", textOverflow:"ellipsis"}}
                    >
                      <option value={"DO VS"}>Select Virtual Stop</option>
                      {virtualStopDropDownHTML}
                    </select>
                    {walkDistance.DOWalk !== 0?<p className="m-0 d-inline-flex user-select-none text-nowrap">{"("+walkDistance.DOWalk+"mi, "+walkDistance.DODuration+"min)"}</p>: ""}
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col>
                    <p type={"text"} style={{textOverflow:"ellipsis"}} title={zones!==""?zones:"Unknown Zone"} className="overflow-hidden user-select-none text-nowrap m-0 w-100 fw-bold small">
                      {zones !== ""? zones:""}
                    </p>
                    
                  </Col>
                  <Col className="d-inline-flex justify-content-start">
                    <p className='m-0 mx-1 user-select-none small'>Notes</p>
                    <textarea
                      name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                      rows={2}
                      cols={20}
                      placeholder="Drop off extra info..." autoComplete="new_pass"
                      id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                      style={{resize:"none"}} value={dropExtraInfo} onChange={(e)=>setDropExtraInfo(e.target.value)}
                      className="tripDetails-label-dataFields d-inline-flex w-100"
                    />                   
                  </Col>
                </Row>
              </Col>
            </Row> {/* Equipment & total passengers row*/}
            <Row className="m-0">
              <Col xs={2}>

              </Col>
              <Col xs={8} className="d-inline-flex">
                <span className="d-inline-flex small my-1 text-nowrap">
                  <Icon icon="bx:group" className="my-2 text-secondary" style={{width:"25px", height:"25px"}}/>
                  <label className='m-0 my-2 user-select-none' title={"Ambulatory Passenger Count"}>Pass.</label>
                  <input type={"number"} maxLength={2} value={passengerTypeCount.ambPass} style={{minWidth:"25px"}} 
                    name="ambPass" onChange={handlePassCountTotal} autoComplete="new_pass"
                    className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers no-counter'
                  />
                </span>
                <span className="d-inline-flex small my-1 text-nowrap">
                  <Icon icon="bx:handicap" className="my-2 text-primary" style={{width:"25px", height:"25px"}}/>
                  <label className='m-0 my-2 user-select-none' title={"WheelChair Passenger Count"}>WC</label>
                  <input type={"number"} maxLength={2} value={passengerTypeCount.totalWC} 
                    style={{minWidth:"25px"}} name="totalWC" onChange={handlePassCountTotal} autoComplete="new_pass"
                    className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers no-counter'
                  />
                </span>
                <span className="d-inline-flex small my-1 text-nowrap">
                  <span className="material-symbols-outlined my-2 user-select-none" style={{width:"25px", height:"25px", color:"#C4A484"}}>
                    pets
                  </span>
                  <label className='m-0 my-2 user-select-none' title={"Service Animal Count"}>SA</label>
                  <input type={"number"} maxLength={2} value={passengerTypeCount.totalSA} style={{minWidth:"25px"}} name="totalSA" onChange={handlePassCountTotal} 
                    className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers no-counter' autoComplete="new_pass"
                  />
                </span>
                <span className="d-inline-flex small my-1 text-nowrap">
                  <label className='m-0 my-2 user-select-none' title={"Total Passengers Count"}>Total</label>
                  <input type={"text"} value={passengerTypeCount.total} style={{minWidth:"25px"}} name="total"  autoComplete="new_pass"
                    disabled  className='text-nowrap border-1 p-1 m-1 w-25 text-center' title={"Total Passengers Count: "+passengerTypeCount.total}
                  />
                </span>
              </Col>
            </Row> 
            <Row className="">
              <Col xs={2}>
                <span className="d-block mt-1 small text-nowrap" title={"Callback phone number"}>
                  <Icon icon="bx:phone" className="m-1" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 user-select-none'>Callback</label>
                </span>
              </Col>
              <Col xs={10} className="p-0">
                <Row className="m-0">
                  <Col className="p-0 px-1">
                    <PhoneInput className='text-nowrap text-center text-center w-100' style={{minWidth:"120px"}}
                      defaultCountry="US" value={callBackPhone} onChange={setCallBackPhone} placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                      onKeyDown={(e)=>{if(callBackPhone && callBackPhone.length >= 12 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab"){e.preventDefault();}}}
                    /> 
                  </Col>
                  <Col className="d-inline-flex justify-content-start ms-4 p-0">
                    {/* <input type={"checkbox"} title={"Enable time selection"} style={{cursor:"pointer"}} onKeyDown={(e)=>{
                        if(e.key === "Enter")
                        {
                          if(enableTimeSelection)
                          {
                            setSchTime(getCurrentTimeInNY());
                            setEnableTimeSelection(false);
                          }
                          else
                          {
                            setEnableTimeSelection(true);
                          }
                        }
                      }} checked={enableTimeSelection} onChange={(e)=>{setEnableTimeSelection(e.target.checked); if(e.target.checked===false){setSchTime(getCurrentTimeInNY());}}}
                    /> */}
                    <p className='m-0 mx-1 user-select-none my-auto small text-start' style={{minWidth:"40px"}} title={"Reservation Time"}>{"Time"}</p>
                                      <input type="time" value={schTime} onChange={(e) => { setSchTime(e.target.value); }} onBlur={handleSchTimeBlur} onClick={schTimeOnClick} onFocus={schTimeOnFocus}
                      className="m-0 px-1 float-end w-100 text-center" style={{minWidth:"110px"}} disabled={isSchTimeFieldDisabled}
                    />
                    <span title={"Clear Time"} onClick={clearSchTime}><Icon icon="bx:reset" className="m-0" style={{width:"20px", height:"20px", cursor:"pointer", color:"black"}}/></span>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className=""> {/*Remaining payment, callback, and Rider ID row */}
              <Col xs={2}>
                {/* <span className="d-block mt-1 small text-nowrap" title={"Callback phone number"}>
                  <Icon icon="bx:phone" className="m-1" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 user-select-none'>Callback</label>
                </span> */}
                <span className="d-block small mt-2 text-nowrap" title={"Funding Source"}>
                  <Icon icon="bx:money" className="m-1 text-success" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 user-select-none'>FS</label>
                </span>
                <span className="d-block small mt-3 text-nowrap" title={"Payment Type Selection"}>
                  <Icon icon="bx:credit-card" className="m-1 text-warning" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 user-select-none'>Payment</label>
                </span>
                {/* <span className="d-block small mt-3">
                  <Icon icon="bx:support" className="m-1" style={{width:"15px", height:"15px"}}/>
                  <label className='m-0 user-select-none' title={"Agent notes regarding the trip"}> Agent Notes</label>
                </span> */}
              </Col>
              <Col xs={10} className="p-0">
                <Row className="m-0">
                  <Col className="p-0 px-1">
                    {/* <PhoneInput className='text-nowrap text-center text-center w-100' style={{minWidth:"120px"}} autoComplete="new_pass"
                      defaultCountry="US" value={callBackPhone} onChange={setCallBackPhone} placeholder="(XXX) XXX-XXXX"
                      onKeyDown={(e)=>{if(callBackPhone && callBackPhone.length >= 12 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab"){e.preventDefault();}}}
                    />  */}
                    <Row className="m-0">
                      <Col className="p-0">
                        <select className='text-center mt-1 p-1 d-inline-flex w-100' value={FSSelected} onChange={(e)=>{setFSSelected(e.target.value);}} 
                          style={{minWidth:"120px"}}
                        >
                          {FSDropdown && FSDropdown.length > 0 ? FSDropdown:""}
                        </select>
                      </Col>
                      {/* <Col xs={8} className="p-0 d-inline-flex">
                        <span className=" small my-2 text-nowrap">
                          <Icon icon="bx:id-card" className="m-1" style={{width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none' title={"Rider ID Number"}>RiderID</label>
                        </span>
                        <input type={"text"}  className='w-50 text-nowrap border-1 p-1 mt-1 mx-1 text-center'/>
                      </Col> */}
                      <select className='d-block mt-1 text-center p-1 w-100' style={{minWidth:"120px"}}
                        value={PaySelected} onChange={(e)=>{setPaySelected(e.target.value);}}
                      >
                        {PayDropdown && PayDropdown.length > 0 ? PayDropdown:""}
                      </select>
                    </Row>
                  </Col>
                  <Col className="d-inline-flex justify-content-start ms-4 p-0">
                    {/* <Row>
                      <Col>
                        <span className="d-inline-flex small">
                          <Icon icon="bx:support" className="m-1" style={{width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none'>{"Agent Notes"}</label>
                          <textarea
                            name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                            rows={3}
                            cols={30}
                            placeholder="Extra Comments..."
                            id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                            style={{resize:"none"}}
                            value={agentNotes}
                            onChange={(e)=>setAgentNotes(e.target.value)}
                            className="tripDetails-label-dataFields w-100 d-inline-flex mt-1 mx-1 float-start  "
                          />
                        </span>
                        
                      </Col>
                    </Row> */}
                    <p className='m-0 mx-1 user-select-none small' style={{maxWidth:"40px"}} title={"Agent Notes"}>{"Agent Notes"}</p>
                      <textarea
                        name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                        rows={2}
                        cols={20}
                        ref={agentNotesBtnRef}
                        placeholder="Extra Comments..."
                        id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                        style={{resize:"none"}}
                        value={agentNotes} autoComplete="new_pass"
                        onChange={(e)=>setAgentNotes(e.target.value)}
                        className="tripDetails-label-dataFields w-100 d-inline-flex mt-1"
                        onKeyDown={(e)=>
                        { 
                          try{
                            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
                            {
                              if(e.key === "Tab" && !e.shiftKey)
                              {
                                e.preventDefault();
                                if(!bookBtnRef.current.disabled)
                                {
                                  bookBtnRef.current.focus();
                                }
                                else
                                {
                                  resetBtnRef.current.focus();
                                }
                              }
                            }
                          }
                          catch(err){console.log(err);}
                        }}
                      />
                    
                  </Col>
                </Row>
              </Col>
            </Row>
          </Row>
          
        </Col>
        <Col xs={6} className={`${clientInfoDisplay? '':'offset-6'} text-start border-start border-secondary callAgentSummaryScroller`} style={{maxHeight:"361px"}}> {/* Summary row*/}
          <Row className="overflow-auto">
            <Col className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#346492"}}>
              <Row>
                <p className="m-0 w-50 fw-bold text-start user-select-none text-nowrap">MTSM Negotiation</p>
                <span className="w-50"  style={{float:"right", display:"inline-flex", justifyContent: "flex-end", alignItems:"center"}}>
                  <label style={{fontSize:"14px"}} className="user-select-none">Records:</label>
                  <label style={{paddingLeft:"5px", fontSize:"14px"}} className="user-select-none">{TotalMTSMRecords}</label>
                </span>
              </Row>
              <Row className="m-0 overflow-auto callAgentSummaryScroller" style={{maxHeight:"150px", minHeight:"140px"}}>
                <table className="w-100 border border-dark my-1" >
                  <thead>
                      <tr className="text-center text-nowrap" style={{background:"rgb(37 82 125)"}}>
                        <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"19%"}}>{"Confirmation"}</th>
                        <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"18%"}}>{"Sch PickTime"}</th>
                        <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"18%"}}>{"Sch DropTime"}</th>
                        <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"19%"}}>{"Name"}</th>
                        <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"35%"}}>{"Msg"}</th>
                        <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500"}}>{"Actions"}</th>
                      </tr>
                  </thead>
                  <tbody>
                    {MTSMTableHTML ? MTSMTableHTML
                    : 
                    <tr className="text-center">
                      <td className="border border-dark user-select-none">{""}</td>
                      <td className="border border-dark user-select-none">{""}</td>
                      <td className="border border-dark user-select-none">{""}</td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""}
                        style={{textOverflow:"ellipsis"}}
                      >{""}</td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""} 
                        style={{textOverflow:"ellipsis"}}
                      >{""}</td>
                      <td className="user-select-none text-center justify-content-center">
                        {""}
                      </td>
                    </tr>
                    } 
                  </tbody>
                </table>
              </Row>
              
            </Col>
          </Row>
          <Row className="" style={{height:"197px"}}>
            <Col xs={6} className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#07447b", maxHeight:"200px"}}>
              <Row className="mt-1">
                <p className="m-0 fw-bold text-start user-select-none text-nowrap">Client Summary</p>
              </Row>
              <table className="m-1">
                  <tbody>
                    <tr className="text-start">
                      <td className="user-select-none small text-nowrap">{"Total Calls"}</td>
                      <td className="user-select-none">
                        <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px"}} value={clientSummary.totalCalls} title={clientSummary.totalCalls} 
                          className='text-nowrap border-1   p-1 mt-1 w-100 text-center text-white'
                        />
                      </td>
                    </tr>
                    <tr className="text-start">
                      <td className="user-select-none small text-nowrap" title={"Total No-Shows"}>{"Total NS"}</td>
                      <td className="user-select-none">
                        <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px"}} value={clientSummary.totalNS} title={clientSummary.totalNS} 
                          className='text-nowrap border-1   p-1 my-1 w-100 text-center text-white'
                        />
                      </td>
                    </tr>
                    <tr className="text-start">
                      <td className="user-select-none small text-nowrap">{"Total Cancelled"}</td>
                      <td className="user-select-none">
                        <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px"}} value={clientSummary.totalCancels} title={clientSummary.totalCancels} 
                          className='text-nowrap border-1   p-1 my-1 mt-0 w-100 text-center text-white'
                        />
                      </td>
                    </tr>
                    {/* <tr className="text-start">
                      <td className="user-select-none small text-nowrap">{"Last Call"}</td>
                      <td className="user-select-none">
                        <input type={"text"} min={0} disabled style={{minWidth:"45px"}} value={clientSummary.lastCall} title={clientSummary.lastCall}
                          className='text-nowrap border-1   p-1 my-1 w-100 text-start text-white'
                        />
                      </td>
                    </tr> */}
                  </tbody>
                </table>
            </Col>
            <Col xs={6} className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#415f7b"}}>
              <Row className="mt-1">
                <p className="m-0 fw-bold text-start user-select-none text-nowrap">Trip Estimates</p>
              </Row>
              <table className="m-1">
                  <tbody>
                    <tr className="text-start">
                      <td className="user-select-none small" title={"Distance (miles)"}>{"Distance"}</td>
                      <td className="user-select-none">
                        <input type={"text"} disabled value={clientSummary.tripDistance} style={{minWidth:"45px"}}
                          title={"Distance: "+clientSummary.tripDistance+" miles"} className='text-nowrap border-1 p-1 mt-1 mx-1 w-100 text-center text-white'
                        />
                      </td>
                    </tr>
                    <tr className="text-start">
                      <td className="user-select-none small" title={"Time (min)"}>{"Time"}</td>
                      <td className="user-select-none">
                        <input type={"text"} disabled value={clientSummary.TripDuration} style={{minWidth:"45px"}}
                          title={"Duration: "+clientSummary.TripDuration+" min"} className='text-nowrap border-1 p-1 my-1 mx-1 w-100 text-center text-white'
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="" style={{height:`calc(100vh - 530px)`, marginLeft: "10%", marginRight:"10%"}}>
        <Col className="p-0 my-1 border-0" style={{boxShadow:"0px 3px 6px #999"}}>
          <MapControlSkeleton
            setIsSchTimeFieldDisabled={setIsSchTimeFieldDisabled}
            setIsVSSelectionDisabled={setIsVSSelectionDisabled}
            vsSelection={handleMapVSSelected}
            mapPointSelection={handleMapPointSelection}
            zones={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
              ((RCZZoneVerticesData && RCZZoneVerticesData.Table.length > 0) ? RCZZoneVerticesData.Table : ZoneVerticesData.Table) : ZoneVerticesData.Table)
            }
            MapDetailData={mapData} 
            options={mapOptionsCallAgent}
            DispatchVehicleData={DispatchVehicleData}
            CurrentAff = {selectedAff}
            onConditionMet={conditionMet ? triggerMapMethod : null}
          />
        </Col>
      </Row>
      <Row className="m-0 p-1 page-footer fixed-bottom" style={{backgroundColor:"#07447b", height:'45px'}}>
        <Col className="text-start" style={{marginLeft:"10%"}}>
          <Row>
            <Col xs={4}>
              <span className="d-inline-flex small text-nowrap text-white">
                <label className='m-0 my-1 user-select-none' title={"Last Confirmation Number"}>Last Confirmation#</label>
                <input type={"text"} disabled value={confirmationNo} onChange={(e)=>setConfirmationNo(e.target.value)}  
                  className='d-inline-flex text-nowrap text-center text-white border-1 mx-1 p-1'
                />
              </span>
            </Col>
            
          </Row>
        </Col>
        <Col className="text-end" style={{marginRight:"9%"}}>
          {/* <Button variant="dark" className="mx-1" onClick={handleAutoBookTrip}>{"Auto"}</Button> */}
          <Button tabIndex={0} variant="success" className="mx-1 rounded" style={{ borderRadius: "0px"}} ref={bookBtnRef} 
            onClick={handleCreateUpdateTrip}
            onKeyDown={(e)=>
              { 
                try{
                  if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
                  {
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      agentNotesBtnRef.current.focus();
                    }
                  }
                }
                catch(err){console.log(err);}
              }
            }
          >
            {submitBtnTitle}
          </Button>
          <Button tabIndex={0} variant="info" className="mx-1 rounded" ref={resetBtnRef} style={{ borderRadius: "0px"}} 
            title={"Reset Parameters"} onClick={()=>{handleResetAll("none")}}
            onKeyDown={(e)=>
              { 
                try{
                  if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
                  {
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      if(bookBtnRef.current.disabled)
                      {
                        agentNotesBtnRef.current.focus();
                      }
                      else
                      {
                        bookBtnRef.current.focus();
                      }
                    }
                    else if(e.key === "Tab" && !e.shiftKey)
                    {
                      e.preventDefault();
                      phoneRef.current.focus();
                    }
                  }
                }
                catch(err){console.log(err);}
              }
            }
          >
            {"Reset"}
          </Button>
          {/* <Button variant="secondary" className="mx-1" style={{ borderRadius: "0px"}} onClick={handleCloseEditTrip} title={"Cancel Action"}>Cancel</Button> */}
        </Col>
      </Row>
      {showClientActiveTripsModal ? 
        <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowClientActiveTripsModal(false)} size={"xl"} show={showClientActiveTripsModal} animation={true}>
          <Modal.Header className='text-white activate_dialog_header_bgcolor user-select-none p-0 py-1 px-2' closeButton>
              <Modal.Title style={{fontSize:"20px"}}>
                {"Client Active Trips"}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none'>
            {clientInfo?<Row className="m-0 d-flex">
              <Col xs={3} className="p-0">
                <p className="m-0">{"Name: "}<span className="fw-normal">{clientInfo.FirstName + " " + clientInfo.LastName}</span></p>
                <p className="m-0">{"Home Phone: "}<span className="fw-normal">{clientInfo.HomePhone? clientInfo.HomePhone:"N/A"}</span></p>
              </Col>
              <Col xs={9} className="p-0">
                <p className="m-0">{"Last Call: "}
                  <span className="fw-normal">{clientInfo.LastCallDate? clientInfo.LastCallDate.split("T")[0]+" "+clientInfo.LastCallDate.split("T")[1].split(".")[0]:"N/A"}</span>
                </p>
                <p className="m-0">{"Phone: "}<span className="fw-normal">{clientInfo.OfficePhone? clientInfo.OfficePhone:"N/A"}</span></p>
              </Col>
            </Row>:""}
            <Row className="m-0 mt-4">
              <GridControl ShowLoader={showLoader} ReloadDataFunction={handleClientInfoTableOpen} setActiveTripConfirmation={setActiveTripConfirmation} Data={ActiveTripsTableData} options={activeTripsGridOptions}/>
            </Row>
          </Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            <Button variant="secondary" className="mx-1" onClick={()=>setShowClientActiveTripsModal(false)} title={"Close client info table"}>Close</Button>
          </Modal.Footer>
        </Modal>
      : ""}
      {showDynamicModal ? 
        <Modal centered className={modalClass} backdrop="static" keyboard={true} onKeyDown={(e)=>{
            if(e.key === "Enter")
            {
              setShowDynamicModal(false);
            }
          }} 
          onHide={()=>setShowDynamicModal(false)} show={showDynamicModal} animation={true}>
            <Modal.Header className='text-white activate_dialog_header_bgcolor user-select-none p-0 py-1 px-2' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
            {modalFooterHTML === ""? "":
              <Modal.Footer className='p-0 px-2 py-1'>
                {modalFooterHTML}
              </Modal.Footer>
            }
        </Modal>
      : ""}
    </>
  );
};

export default CallTaker;